(function () {
  "use strict";
  var e = {
      4215: function (e, t, a) {
        var o = a(5130),
          i = a(3367),
          s = a(8253),
          d = a(8077),
          n = a(6768),
          c = a(144);
        const r = { id: "header-bar" },
          l = (0, n.Fv)(
            '<div class="row p-0" data-v-6af62400><div class="col py-1 barCustom" data-v-6af62400><div class="pe-2 text-end text-white" data-v-6af62400>CARDIO-RENAL-METABOLIC</div></div></div><div class="row px-3 py-0 align-items-center" data-v-6af62400><div class="col-12" data-v-6af62400><h1 class="larger-header mt-2" data-v-6af62400>The Interactive Cardio-Renal-Metabolic Map</h1></div><div class="row px-3" data-v-6af62400><div class="col-12" data-v-6af62400><div data-v-6af62400> The interactive map below provides insight into the impact of cardio-renal-metabolic conditions in the Medicare and Commercial populations in the United States. Use it to investigate the prevalence of these conditions at the state- and country- level, explore the health burden associated with these diseases, and learn about their economic impact. </div></div></div><div class="row mx-3 px-5 pt-2" data-v-6af62400><span class="border-bottom border-primary" data-v-6af62400></span></div></div>',
            2
          ),
          m = [l];
        function p(e, t) {
          return (0, n.uX)(), (0, n.CE)("div", r, m);
        }
        var u = a(1241);
        const _ = {},
          b = (0, u.A)(_, [
            ["render", p],
            ["__scopeId", "data-v-6af62400"],
          ]);
        var v = b,
          h = a(4232);
        a(4114),
          a(3375),
          a(9225),
          a(3972),
          a(9209),
          a(5714),
          a(7561),
          a(6197),
          a(4603),
          a(7566),
          a(8721);
        const y = {
            0: [
              { condCode: "t2d", dataTag: "t2d_x_flag" },
              { condCode: "cvd", dataTag: "cvd_x_flag" },
              { condCode: "hf", dataTag: "hf_any_x_flag" },
              { condCode: "ckd", dataTag: "ckd_any_x_flag" },
              { condCode: "ckd_12", dataTag: "ckd12_x_flag" },
              { condCode: "ckd_345", dataTag: "ckd345_x_flag" },
              { condCode: "htn", dataTag: "htn_x_flag" },
              { condCode: "ckd_0", dataTag: "at_risk_crm" },
              { condCode: "ckd_1", dataTag: "ckd1_x_flag" },
              { condCode: "ckd_2", dataTag: "ckd2_x_flag" },
              { condCode: "ckd_3", dataTag: "ckd3_x_flag" },
              { condCode: "ckd_4", dataTag: "ckd4_x_flag" },
              { condCode: "ckd_5", dataTag: "ckd5_x_flag" },
              { condCode: "afib", dataTag: "afib_x_flag" },
              { condCode: "hfpef", dataTag: "hfpef_x_flag" },
              { condCode: "hfref", dataTag: "hfref_x_flag" },
              { condCode: "ihd", dataTag: "ihd_x_flag" },
              { condCode: "stroke", dataTag: "stroke_x_flag" },
              { condCode: "obesity", dataTag: "obesity_x_flag" },
            ],
            1: [
              {
                condCode: "t2d",
                comorb1: "obesity",
                dataTag: "t2d_x_flag_obesity",
              },
              { condCode: "t2d", comorb1: "cvd", dataTag: "t2d_1_cvd_1_ckd_a" },
              { condCode: "t2d", comorb1: "hf", dataTag: "t2d_1_hf_1_ckd_a" },
              { condCode: "t2d", comorb1: "ckd", dataTag: "t2d_1_cvd_a_ckd_1" },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                dataTag: "t2d_1_cvd_a_ckd12_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                dataTag: "t2d_1_cvd_a_ckd345_1",
              },
              {
                condCode: "cvd",
                comorb1: "obesity",
                dataTag: "cvd_x_flag_obesity",
              },
              { condCode: "cvd", comorb1: "t2d", dataTag: "t2d_1_cvd_1_ckd_a" },
              { condCode: "cvd", comorb1: "ckd", dataTag: "t2d_a_cvd_1_ckd_1" },
              {
                condCode: "cvd",
                comorb1: "ckd_12",
                dataTag: "t2d_a_cvd_1_ckd12_1",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_345",
                dataTag: "t2d_a_cvd_1_ckd345_1",
              },
              {
                condCode: "hf",
                comorb1: "obesity",
                dataTag: "hf_any_x_flag_obesity",
              },
              { condCode: "hf", comorb1: "t2d", dataTag: "t2d_1_hf_1_ckd_a" },
              { condCode: "hf", comorb1: "ckd", dataTag: "t2d_a_hf_1_ckd_1" },
              {
                condCode: "hf",
                comorb1: "ckd_12",
                dataTag: "t2d_a_hf_1_ckd12_1",
              },
              {
                condCode: "hf",
                comorb1: "ckd_345",
                dataTag: "t2d_a_hf_1_ckd345_1",
              },
              {
                condCode: "ckd",
                comorb1: "obesity",
                dataTag: "ckd_any_x_flag_obesity",
              },
              { condCode: "ckd", comorb1: "cvd", dataTag: "t2d_a_CVD_1_ckd_1" },
              { condCode: "ckd", comorb1: "hf", dataTag: "t2d_a_hf_1_ckd_1" },
              {
                condCode: "ckd",
                comorb1: "t2d",
                dataTag: "t2d_1_cvd_a_ckd_1\nt2d_1_hf_a_ckd_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "obesity",
                dataTag: "ckd12_x_flag_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "cvd",
                dataTag: "t2d_a_CVD_1_ckd12_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "hf",
                dataTag: "t2d_a_hf_1_ckd12_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                dataTag: "t2d_1_cvd_a_ckd12_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "obesity",
                dataTag: "ckd345_x_flag_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "cvd",
                dataTag: "t2d_a_CVD_1_ckd345_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "hf",
                dataTag: "t2d_a_hf_1_ckd345_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                dataTag: "t2d_1_cvd_a_ckd345_1",
              },
              {
                condCode: "htn",
                comorb1: "obesity",
                dataTag: "htn_x_flag_obesity",
              },
              {
                condCode: "ckd_0",
                comorb1: "obesity",
                dataTag: "at_risk_crm_obesity",
              },
            ],
            2: [
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_a_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd",
                dataTag: "t2d_1_cvd_1_ckd_1",
              },
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd_12",
                dataTag: "t2d_1_cvd_1_ckd12_1",
              },
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd_345",
                dataTag: "t2d_1_cvd_1_ckd345_1",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "obesity",
                dataTag: "t2d_1_hf_1_ckd_a_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd_12",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd_345",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd12_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd12_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd345_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd345_1",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_a_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd",
                dataTag: "t2d_1_cvd_1_ckd_1",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd_12",
                dataTag: "t2d_1_cvd_1_ckd12_1",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd_345",
                dataTag: "t2d_1_cvd_1_ckd345_1",
              },
              {
                condCode: "cvd",
                comorb1: "ckd",
                comorb2: "obesity",
                dataTag: "t2d_a_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd",
                comorb2: "t2d",
                dataTag: "t2d_1_cvd_1_ckd_1",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_12",
                comorb2: "obesity",
                dataTag: "t2d_a_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_12",
                comorb2: "t2d",
                dataTag: "t2d_1_cvd_1_ckd12_1",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_345",
                comorb2: "obesity",
                dataTag: "t2d_a_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_345",
                comorb2: "t2d",
                dataTag: "t2d_1_cvd_1_ckd345_1",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "obesity",
                dataTag: "t2d_1_hf_1_ckd_a_obesity",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd_12",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd_345",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
              {
                condCode: "hf",
                comorb1: "ckd",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "hf",
                comorb1: "ckd_12",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd_12",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "hf",
                comorb1: "ckd_345",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd345_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd_345",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
              {
                condCode: "ckd",
                comorb1: "cvd",
                comorb2: "obesity",
                dataTag: "t2d_a_CVD_1_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "cvd",
                comorb2: "t2d",
                dataTag: "t2d_1_CVD_1_ckd_1",
              },
              {
                condCode: "ckd",
                comorb1: "hf",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "hf",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "ckd",
                comorb1: "t2d",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd_1_obesity\nt2d_1_hf_a_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "t2d",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd_1",
              },
              {
                condCode: "ckd",
                comorb1: "t2d",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "cvd",
                comorb2: "obesity",
                dataTag: "t2d_a_CVD_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "cvd",
                comorb2: "t2d",
                dataTag: "t2d_1_CVD_1_ckd12_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "hf",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "hf",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd12_1",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd12_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "cvd",
                comorb2: "obesity",
                dataTag: "t2d_a_CVD_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "cvd",
                comorb2: "t2d",
                dataTag: "t2d_1_CVD_1_ckd345_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "hf",
                comorb2: "obesity",
                dataTag: "t2d_a_hf_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "hf",
                comorb2: "t2d",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                comorb2: "obesity",
                dataTag: "t2d_1_cvd_a_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                comorb2: "cvd",
                dataTag: "t2d_1_cvd_1_ckd345_1",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                comorb2: "hf",
                dataTag: "t2d_1_hf_1_ckd345_1",
              },
            ],
            3: [
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd_12",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "cvd",
                comorb2: "ckd_345",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd_12",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd12_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "hf",
                comorb2: "ckd_345",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd345_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_12",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "t2d",
                comorb1: "ckd_345",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd345_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd_12",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "t2d",
                comorb2: "ckd_345",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_12",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "cvd",
                comorb1: "ckd_345",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd_12",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd12_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "t2d",
                comorb2: "ckd_345",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_a_ckd345_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd_12",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "hf",
                comorb1: "ckd_345",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "cvd",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_CVD_1_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "hf",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "t2d",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "ckd",
                comorb1: "t2d",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "cvd",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_CVD_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "hf",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_12",
                comorb1: "t2d",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd12_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "cvd",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_CVD_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "hf",
                comorb2: "t2d",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                comorb2: "cvd",
                comorb3: "obesity",
                dataTag: "t2d_1_cvd_1_ckd345_1_obesity",
              },
              {
                condCode: "ckd_345",
                comorb1: "t2d",
                comorb2: "hf",
                comorb3: "obesity",
                dataTag: "t2d_1_hf_1_ckd345_1_obesity",
              },
            ],
          },
          k = [
            { id: "01", stateAbbrv: "AL", stateName: "Alabama" },
            { id: "02", stateAbbrv: "AK", stateName: "Alaska" },
            { id: "04", stateAbbrv: "AZ", stateName: "Arizona" },
            { id: "05", stateAbbrv: "AR", stateName: "Arkansas" },
            { id: "06", stateAbbrv: "CA", stateName: "California" },
            { id: "08", stateAbbrv: "CO", stateName: "Colorado" },
            { id: "09", stateAbbrv: "CT", stateName: "Connecticut" },
            { id: "10", stateAbbrv: "DE", stateName: "Delaware" },
            { id: "11", stateAbbrv: "DC", stateName: "District of Columbia" },
            { id: "12", stateAbbrv: "FL", stateName: "Florida" },
            { id: "13", stateAbbrv: "GA", stateName: "Georgia" },
            { id: "15", stateAbbrv: "HI", stateName: "Hawaii" },
            { id: "16", stateAbbrv: "ID", stateName: "Idaho" },
            { id: "17", stateAbbrv: "IL", stateName: "Illinois" },
            { id: "18", stateAbbrv: "IN", stateName: "Indiana" },
            { id: "19", stateAbbrv: "IA", stateName: "Iowa" },
            { id: "20", stateAbbrv: "KS", stateName: "Kansas" },
            { id: "21", stateAbbrv: "KY", stateName: "Kentucky" },
            { id: "22", stateAbbrv: "LA", stateName: "Louisiana" },
            { id: "23", stateAbbrv: "ME", stateName: "Maine" },
            { id: "24", stateAbbrv: "MD", stateName: "Maryland" },
            { id: "25", stateAbbrv: "MA", stateName: "Massachusetts" },
            { id: "26", stateAbbrv: "MI", stateName: "Michigan" },
            { id: "27", stateAbbrv: "MN", stateName: "Minnesota" },
            { id: "28", stateAbbrv: "MS", stateName: "Mississippi" },
            { id: "29", stateAbbrv: "MO", stateName: "Missouri" },
            { id: "30", stateAbbrv: "MT", stateName: "Montana" },
            { id: "31", stateAbbrv: "NE", stateName: "Nebraska" },
            { id: "32", stateAbbrv: "NV", stateName: "Nevada" },
            { id: "33", stateAbbrv: "NH", stateName: "New Hampshire" },
            { id: "34", stateAbbrv: "NJ", stateName: "New Jersey" },
            { id: "35", stateAbbrv: "NM", stateName: "New Mexico" },
            { id: "36", stateAbbrv: "NY", stateName: "New York" },
            { id: "37", stateAbbrv: "NC", stateName: "North Carolina" },
            { id: "38", stateAbbrv: "ND", stateName: "North Dakota" },
            { id: "39", stateAbbrv: "OH", stateName: "Ohio" },
            { id: "40", stateAbbrv: "OK", stateName: "Oklahoma" },
            { id: "41", stateAbbrv: "OR", stateName: "Oregon" },
            { id: "42", stateAbbrv: "PA", stateName: "Pennsylvania" },
            { id: "44", stateAbbrv: "RI", stateName: "Rhode Island" },
            { id: "45", stateAbbrv: "SC", stateName: "South Carolina" },
            { id: "46", stateAbbrv: "SD", stateName: "South Dakota" },
            { id: "47", stateAbbrv: "TN", stateName: "Tennessee" },
            { id: "48", stateAbbrv: "TX", stateName: "Texas" },
            { id: "49", stateAbbrv: "UT", stateName: "Utah" },
            { id: "50", stateAbbrv: "VT", stateName: "Vermont" },
            { id: "51", stateAbbrv: "VA", stateName: "Virginia" },
            { id: "53", stateAbbrv: "WA", stateName: "Washington" },
            { id: "54", stateAbbrv: "WV", stateName: "West Virginia" },
            { id: "55", stateAbbrv: "WI", stateName: "Wisconsin" },
            { id: "56", stateAbbrv: "WY", stateName: "Wyoming" },
          ];
        function f(e, t) {
          try {
            return t.filter((t) => t.displayName === e)[0].code;
          } catch (a) {
            return "";
          }
        }
        function g(e, t) {
          try {
            return t.find((t) => t.displayName === e)?.format || "";
          } catch (a) {
            return "";
          }
        }
        function C(e) {
          const t = {
            t2d: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              {
                code: "cvd",
                displayName: "Cardiovascular disease",
                showDD: !0,
              },
              { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              {
                code: "ckd",
                displayName: "Chronic kidney disease (any stage)",
                showDD: !0,
              },
              {
                code: "ckd_12",
                displayName: "Chronic kidney disease (stages 1,2)",
                showDD: !0,
              },
              {
                code: "ckd_345",
                displayName: "Chronic kidney disease (stages 3,4,5)",
                showDD: !0,
              },
            ],
            cvd: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              {
                code: "ckd",
                displayName: "Chronic kidney disease (any stage)",
                showDD: !0,
              },
              {
                code: "ckd_12",
                displayName: "Chronic kidney disease (stages 1,2)",
                showDD: !0,
              },
              {
                code: "ckd_345",
                displayName: "Chronic kidney disease (stages 3,4,5)",
                showDD: !0,
              },
            ],
            hf: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              {
                code: "ckd",
                displayName: "Chronic kidney disease (any stage)",
                showDD: !0,
              },
              {
                code: "ckd_12",
                displayName: "Chronic kidney disease (stages 1,2)",
                showDD: !0,
              },
              {
                code: "ckd_345",
                displayName: "Chronic kidney disease (stages 3,4,5)",
                showDD: !0,
              },
            ],
            ckd: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              {
                code: "cvd",
                displayName: "Cardiovascular disease",
                showDD: !0,
              },
              { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
            ],
            ckd_12: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              {
                code: "cvd",
                displayName: "Cardiovascular disease",
                showDD: !0,
              },
              { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
            ],
            ckd_345: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
              {
                code: "cvd",
                displayName: "Cardiovascular disease",
                showDD: !0,
              },
              { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
            ],
            ckd_0: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
            ],
            htn: [
              { code: "", displayName: "", showDD: !1 },
              { code: "obesity", displayName: "Obesity", showDD: !1 },
            ],
          };
          return t.hasOwnProperty(e)
            ? t[e]
            : [{ code: "", displayName: "", showDD: !1 }];
        }
        function L(e, t) {
          const a = {
            t2d: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              cvd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "ckd",
                  displayName: "Chronic kidney disease (any stage)",
                  showDD: !0,
                },
                {
                  code: "ckd_12",
                  displayName: "Chronic kidney disease (stages 1,2)",
                  showDD: !0,
                },
                {
                  code: "ckd_345",
                  displayName: "Chronic kidney disease (stages 3,4,5)",
                  showDD: !0,
                },
              ],
              hf: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "ckd",
                  displayName: "Chronic kidney disease (any stage)",
                  showDD: !0,
                },
                {
                  code: "ckd_12",
                  displayName: "Chronic kidney disease (stages 1,2)",
                  showDD: !0,
                },
                {
                  code: "ckd_345",
                  displayName: "Chronic kidney disease (stages 3,4,5)",
                  showDD: !0,
                },
              ],
              ckd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
              ckd_12: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
              ckd_345: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
            },
            cvd: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              t2d: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "ckd",
                  displayName: "Chronic kidney disease (any stage)",
                  showDD: !0,
                },
                {
                  code: "ckd_12",
                  displayName: "Chronic kidney disease (stages 1,2)",
                  showDD: !0,
                },
                {
                  code: "ckd_345",
                  displayName: "Chronic kidney disease (stages 3,4,5)",
                  showDD: !0,
                },
              ],
              ckd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              ckd_12: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              ckd_345: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
            },
            hf: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              t2d: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "ckd",
                  displayName: "Chronic kidney disease (any stage)",
                  showDD: !0,
                },
                {
                  code: "ckd_12",
                  displayName: "Chronic kidney disease (stages 1,2)",
                  showDD: !0,
                },
                {
                  code: "ckd_345",
                  displayName: "Chronic kidney disease (stages 3,4,5)",
                  showDD: !0,
                },
              ],
              ckd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              ckd_12: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              ckd_345: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
            },
            ckd: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              cvd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              hf: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              t2d: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
            },
            ckd_12: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              cvd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              hf: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              t2d: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
            },
            ckd_345: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
              cvd: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              hf: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
              ],
              t2d: [
                { code: "", displayName: "", showDD: !1 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
              ],
            },
            htn: {
              "": [{ code: "", displayName: "", showDD: !1 }],
              obesity: [{ code: "", displayName: "", showDD: !1 }],
            },
          };
          return a.hasOwnProperty(e) && a[e].hasOwnProperty(t)
            ? a[e][t]
            : [{ code: "", displayName: "", showDD: !1 }];
        }
        function D(e, t, a, o, i = void 0) {
          const s = O();
          let d;
          const n = "states" == t ? "" : "County";
          if (a) {
            const t = s.liveNationMap - a,
              i = t > 0 ? "below" : "above",
              c = N(a, o),
              r = N(Math.abs(t), o);
            d = `\n        <div class='fw-bold'> ${e} ${n} </div>\n        <div> ${s.liveMetric} of <span class='fw-bold'>${c}</span> </div>\n        <div> This is ${r} ${i} the national average </div>\n        `;
          } else
            d = `\n        <div class='fw-bold'> ${e} ${n} </div>\n        <div> ${s.liveMetric} is missing or unknown </div>\n        `;
          return d;
        }
        function w(e) {
          return e
            .toLowerCase()
            .split(" ")
            .map((e) => e.charAt(0).toUpperCase() + e.slice(1))
            .join(" ");
        }
        function T(e, t, a) {
          const o = y[String(e)];
          let i = "";
          switch (e) {
            case 0:
              i = o.find((e) => e.condCode === t)?.dataTag;
              break;
            case 1:
              i = o.find((e) => e.condCode === t && e.comorb1 === a[0])
                ?.dataTag;
              break;
            case 2:
              i = o.find(
                (e) =>
                  e.condCode === t && e.comorb1 === a[0] && e.comorb2 === a[1]
              )?.dataTag;
              break;
            case 3:
              i = o.find(
                (e) =>
                  e.condCode === t &&
                  e.comorb1 === a[0] &&
                  e.comorb2 === a[1] &&
                  e.comorb3 === a[2]
              )?.dataTag;
              break;
            default:
              i = "";
          }
          return i;
        }
        function N(e, t) {
          const a = "string" === typeof e ? parseFloat(e) : e;
          switch (t) {
            case "percent":
              return `${a.toFixed(0)}%`;
            case "cost":
              return `${a.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}`;
            case "rate":
              return `${a.toFixed(0)} per 1,000`;
            case "integer":
              return `${a.toFixed(1)}`;
            default:
              return a.toFixed(1);
          }
        }
        function M(e, t) {
          const a = Number(e);
          return "percent" == t ? 100 * a : a;
        }
        function A(e, t) {
          return Object.values(
            e.reduce((e, a) => {
              const { YEAR: o } = a;
              return (
                (e[o] = e[o] || { YEAR: o }),
                t.forEach((t) => {
                  e[o][t] = (e[o][t] || 0) + Number(a[t]);
                }),
                e
              );
            }, {})
          );
        }
        function S(e) {
          const t = e.map((e) => ({
            ...e,
            PREV: e.N_MEMBERS_CONDITION / e.N_MEMBERS_DEMOG,
            MORTALITY_PCT: e.MORTALITY_sum / e.N_MEMBERS_CONDITION,
            READMIT_RATE: e.READMISSION_NUMERATOR / e.READMISSION_DENOMINATOR,
            IP_DAYS_PMPY: e.IP_DAYS / e.N_MEMBERS_CONDITION,
            IP_ADM_1000: (e.ADMIT_MEMS / e.N_MEMBERS_CONDITION) * 1e3,
            RPL_THEME1_AVG: e.RPL_THEME1_sum / e.MEMMOS_CONDITION,
            RPL_THEME2_AVG: e.RPL_THEME2_sum / e.MEMMOS_CONDITION,
            RPL_THEME3_AVG: e.RPL_THEME3_sum / e.MEMMOS_CONDITION,
            RPL_THEME4_AVG: e.RPL_THEME4_sum / e.MEMMOS_CONDITION,
            RPL_THEME1_IN_STATE_AVG:
              e.RPL_THEME1_IN_STATE_sum / e.MEMMOS_CONDITION,
            RPL_THEME2_IN_STATE_AVG:
              e.RPL_THEME2_IN_STATE_sum / e.MEMMOS_CONDITION,
            RPL_THEME3_IN_STATE_AVG:
              e.RPL_THEME3_IN_STATE_sum / e.MEMMOS_CONDITION,
            RPL_THEME4_IN_STATE_AVG:
              e.RPL_THEME4_IN_STATE_sum / e.MEMMOS_CONDITION,
            TOTAL_ALLOW_PMPY: e.TOTAL_ALLOWED_sum / e.N_MEMBERS_CONDITION,
            IP_ALLOW_PMPY: e.TOTAL_ALLOWED_ip_sum / e.N_MEMBERS_CONDITION,
            PAC_ALLOW_PMPY: e.TOTAL_ALLOWED_pac_sum / e.N_MEMBERS_CONDITION,
            IP_MEMS_PCT: e.IP_ADMIT_FLAG_sum / e.N_MEMBERS_CONDITION,
          }));
          return t;
        }
        function E(e) {
          return e.startsWith("0") && e.length > 1 ? e.slice(1) : e;
        }
        function I(e) {
          const t = k.find((t) => t.id === e),
            a = t?.stateAbbrv ? t.stateAbbrv : void 0;
          return a;
        }
        function x(e) {
          const t = k.find((t) => t.stateAbbrv === e),
            a = t?.id ? t.id : void 0;
          return a;
        }
        const R = (0, i.nY)("spatialStore", {
            state: () => ({
              spatialBase: null,
              abbrvMap: k,
              countyNames: [],
              stateNames: [],
              liveNames: [],
              liveMultiSelect: [],
            }),
            getters: {},
            actions: {
              async fetchBaseMap() {
                const e = await fetch(
                  "https://cdn.jsdelivr.net/npm/us-atlas@3/counties-albers-10m.json"
                );
                (this.spatialBase = await e.json()),
                  this.spatialBase &&
                    ((this.countyNames = this.spatialBase.objects.counties.geometries.map(
                      (e) => ({ id: e.id, name: e.properties.name })
                    )),
                    (this.countyNames = this.countyNames.map((e) => ({
                      id: e.id,
                      name: `${e.name},  ${
                        this.abbrvMap.find((t) => e.id.substring(0, 2) === t.id)
                          ?.stateName
                      }`,
                    }))),
                    (this.stateNames = this.spatialBase.objects.states.geometries.map(
                      (e) => ({ id: e.id, name: e.properties.name })
                    )),
                    (this.liveNames = this.stateNames));
              },
              clearMultiSelect() {
                this.liveMultiSelect.length > 0 &&
                  (this.liveMultiSelect.forEach((e) => {
                    const t = document.getElementById(e.id);
                    t?.classList.remove("selected");
                  }),
                  (this.liveMultiSelect = []));
              },
              addCurrentToLive(e) {
                const t = O();
                if (this.liveMultiSelect.length >= t.selectMax)
                  return void alert("Max locations selected");
                if (this.liveMultiSelect.some((t) => t.name === e.name)) return;
                this.liveMultiSelect.push(e);
                const a = document.getElementById(e.id);
                a?.classList.add("selected");
              },
              removeGeoItemFromLive(e) {
                const t = this.liveMultiSelect.findIndex((t) => t.id === e.id);
                console.log(e), this.liveMultiSelect.splice(t, 1);
                const a = document.getElementById(e.id);
                a?.classList.remove("selected");
              },
            },
          }),
          P = (0, i.nY)("modalStore", {
            state: () => ({
              liveModalData: [],
              liveModalNation: [],
              currentGeo: { id: "", name: "" },
              liveCostYear: "",
              yearOptions: [],
              mortIsTrend: !1,
              liveMortYear: "",
              liveHospType: "Hospitalization Rate",
              hospTypeOptions: [
                "Hospitalization Rate",
                "Readmission Rate",
                "Hospital Days",
              ],
              liveTitle: "",
              nestedTrigger: 0,
            }),
            getters: {
              modalTitle(e) {
                const t = O(),
                  a = R();
                if (!(e.currentGeo.name || a.liveMultiSelect.length > 0))
                  return "";
                if ("single" == t.selectMode) {
                  const t = e.currentGeo.name;
                  return (e.liveTitle = t), t;
                }
                if ("multi" == t.selectMode) {
                  const t =
                    a.liveMultiSelect.map((e) => e.name).join(", ") +
                    " Combined";
                  return (e.liveTitle = t), t;
                }
                if ("comp" == t.selectMode) {
                  const t = a.liveMultiSelect.map((e) => e.name).join(" vs ");
                  return (e.liveTitle = t), t;
                }
              },
              legendItems1() {
                const e = O(),
                  t = R();
                return "single" === e.selectMode
                  ? this.modalTitle
                  : "multi" === e.selectMode
                  ? "Combined"
                  : t.liveMultiSelect.map((e) => e.name)[0];
              },
              legendItems2() {
                const e = O(),
                  t = R();
                return "comp" === e.selectMode
                  ? t.liveMultiSelect.map((e) => e.name)[1]
                  : "Nation";
              },
            },
            actions: {
              resetModalSettings() {
                (this.liveCostYear = this.yearOptions[0]),
                  (this.mortIsTrend = !1),
                  (this.liveMortYear = this.yearOptions[0]),
                  (this.liveHospType = "Hospitalization Rate");
              },
              async fetchChartData(e) {
                const t = O();
                let a, o;
                (t.dataLoading = !0),
                  (t.modalLoading = !0),
                  (a = e
                    ? "nation"
                    : "County" === t.liveSpatialStr
                    ? "county"
                    : "state"),
                  (o =
                    "Commercial" == t.liveInsurance &&
                    "State" === t.liveSpatialStr
                      ? I(this.currentGeo.id)
                      : E(this.currentGeo.id));
                const i = new URLSearchParams({
                  cond: t.currentDataTag,
                  FIPS: o,
                  insr: f(t.liveInsurance, t.liveInsuranceCodes),
                  pop: f(t.livePopulation, t.populationCodes),
                  geoLevel: a,
                  per_page: 1e3,
                });
                e && i.delete("FIPS");
                const s = t.baseApiUrl + "chartData?" + i,
                  d = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: t.bearToken,
                  };
                let n = await fetch(s, { headers: d }),
                  c = await n.json();
                e
                  ? ((this.liveModalNation = c),
                    (this.nestedTrigger = Math.random()))
                  : ((this.liveModalData = c),
                    (this.nestedTrigger = Math.random())),
                  (t.dataLoading = !1),
                  (t.modalLoading = !1),
                  (this.liveCostYear = t.liveYear),
                  (this.liveMortYear = t.liveYear);
              },
              async fetchMultiChart(e) {
                const t = O(),
                  a = R();
                (t.dataLoading = !0), (t.modalLoading = !0);
                const o = "State" === t.liveSpatialStr ? "state" : "county",
                  i = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: t.bearToken,
                  };
                let s;
                s =
                  "Commercial" == t.liveInsurance &&
                  "State" === t.liveSpatialStr
                    ? a.liveMultiSelect.map((e) => I(e.id)).join(",")
                    : a.liveMultiSelect.map((e) => E(e.id)).join(",");
                const d = new URLSearchParams({
                    cond: t.currentDataTag,
                    FIPS: s,
                    insr: f(t.liveInsurance, t.liveInsuranceCodes),
                    pop: f(t.livePopulation, t.populationCodes),
                    geoLevel: o,
                    per_page: 1e3,
                  }),
                  n = t.baseApiUrl + "chartData?" + d;
                let c = await fetch(n, { headers: i }),
                  r = await c.json();
                const l = t.yearsList,
                  m = r.data.sort((e, t) => e.YEAR - t.YEAR),
                  p = m.filter((e) => l.includes(String(e.YEAR)));
                if (e) {
                  let e = "state" == o ? "MEM_STATE" : "MEM_COUNTY_FIPS";
                  const i = [...new Set(a.liveMultiSelect.map((e) => e.id))],
                    s = r.data.filter((a) => t.formatFIPS(a[e]) === i[0]),
                    d = r.data.filter((a) => t.formatFIPS(a[e]) === i[1]);
                  (this.liveModalData = { data: s }),
                    (this.liveModalNation = { data: d }),
                    (this.liveCostYear = t.liveYear),
                    (this.liveMortYear = t.liveYear),
                    (this.nestedTrigger = Math.random()),
                    (t.dataLoading = !1),
                    (t.modalLoading = !1);
                } else {
                  const e = A(p, [
                      "N_MEMBERS_DEMOG",
                      "N_MEMBERS_CONDITION",
                      "TOTAL_ALLOW",
                      "IP_ALLOW",
                      "PAC_ALLOW",
                      "IP_DAYS",
                      "ADMIT_MEMS",
                      "MORTALITY_sum",
                      "READMISSION_NUMERATOR",
                      "READMISSION_DENOMINATOR",
                      "RPL_THEME1_sum",
                      "RPL_THEME2_sum",
                      "RPL_THEME3_sum",
                      "RPL_THEME4_sum",
                      "RPL_THEME1_IN_STATE_sum",
                      "RPL_THEME2_IN_STATE_sum",
                      "RPL_THEME3_IN_STATE_sum",
                      "RPL_THEME4_IN_STATE_sum",
                      "MEMMOS_CONDITION",
                      "TOTAL_ALLOWED_sum",
                      "TOTAL_ALLOWED_ip_sum",
                      "TOTAL_ALLOWED_pac_sum",
                    ]),
                    a = S(e),
                    o = { data: a };
                  (this.liveModalData = o), (t.dataLoading = !1);
                }
              },
            },
          }),
          O = (0, i.nY)("optionStore", {
            state: () => ({
              baseApiUrl: "https://crm-heatmap.bi-oneweb.com/api/",
              bearToken:
                "Bearer 1|3GZLEqiMOKzxmt6XdRMlQsilsdis4vNP0XTdlT8b7d715e56",
              liveSpatialStr: "State",
              spatialOptionsStr: ["State", "County"],
              liveCondition: "Type 2 diabetes",
              livePopulation: "Total",
              liveYear: "",
              yearsList: [],
              liveMetric: "Prevalence",
              liveInsurance: "Medicare FFS",
              conditionCodes: [
                { code: "t2d", displayName: "Type 2 diabetes", showDD: !0 },
                {
                  code: "ckd",
                  displayName: "Chronic kidney disease (any stage)",
                  showDD: !0,
                },
                {
                  code: "ckd_12",
                  displayName: "Chronic kidney disease (stages 1,2)",
                  showDD: !0,
                },
                {
                  code: "ckd_345",
                  displayName: "Chronic kidney disease (stages 3,4,5)",
                  showDD: !0,
                },
                {
                  code: "ckd_1",
                  displayName: "Chronic kidney disease (stage 1)",
                  showDD: !1,
                },
                {
                  code: "ckd_2",
                  displayName: "Chronic kidney disease (stage 2)",
                  showDD: !1,
                },
                {
                  code: "ckd_3",
                  displayName: "Chronic kidney disease (stage 3)",
                  showDD: !1,
                },
                {
                  code: "ckd_4",
                  displayName: "Chronic kidney disease (stage 4)",
                  showDD: !1,
                },
                {
                  code: "ckd_5",
                  displayName: "Chronic kidney disease (stage 5)",
                  showDD: !1,
                },
                {
                  code: "ckd_0",
                  displayName: "At risk for chronic kidney disease",
                  showDD: !0,
                },
                {
                  code: "cvd",
                  displayName: "Cardiovascular disease",
                  showDD: !0,
                },
                {
                  code: "afib",
                  displayName: "Atrial fibrillation",
                  showDD: !1,
                },
                { code: "hf", displayName: "Heart failure (any)", showDD: !0 },
                {
                  code: "hfpef",
                  displayName: "Heart failure (pEF)",
                  showDD: !1,
                },
                {
                  code: "hfref",
                  displayName: "Heart failure (rEF)",
                  showDD: !1,
                },
                {
                  code: "ihd",
                  displayName: "Ischemic heart disease",
                  showDD: !1,
                },
                { code: "stroke", displayName: "Stroke", showDD: !1 },
                { code: "htn", displayName: "Hypertension", showDD: !0 },
                { code: "obesity", displayName: "Obesity", showDD: !1 },
              ],
              liveData: [],
              liveNationMap: [],
              dataLoading: !0,
              modalLoading: !1,
              staticSettings: {
                spatial: "State",
                condition: "Type 2 diabetes",
                comorb1: "",
                comorb2: "",
                comorb3: "",
                metric: "Prevalence",
                population: "Total",
                year: "2023",
                insurance: "Medicare FFS",
              },
              liveComorb1: "",
              liveComorb2: "",
              liveComorb3: "",
              comorb3Codes: [
                { code: "", displayName: "" },
                { code: "obesity", displayName: "Obesity" },
              ],
              selectMode: "single",
              isApiIssue: !1,
            }),
            getters: {
              liveInsuranceCodes(e) {
                return "State" == e.liveSpatialStr
                  ? [
                      { code: "MedicareFFS", displayName: "Medicare FFS" },
                      { code: "Commercial", displayName: "Commercial" },
                    ]
                  : [{ code: "MedicareFFS", displayName: "Medicare FFS" }];
              },
              metricCodes(e) {
                const t = [
                    {
                      code: "PREV",
                      displayName: "Prevalence",
                      format: "percent",
                    },
                    {
                      code: "TOTAL_ALLOW_PMPY",
                      displayName: "All-Cause Cost Per Person",
                      format: "cost",
                    },
                    {
                      code: "IP_ALLOW_PMPY",
                      displayName: "Hospital Inpatient Cost Per Person",
                      format: "cost",
                    },
                    {
                      code: "PAC_ALLOW_PMPY",
                      displayName: "Post-Acute Care Cost Per Person",
                      format: "cost",
                    },
                    {
                      code: "MORTALITY_PCT",
                      displayName: "Mortality Rate",
                      format: "percent",
                    },
                    {
                      code: "IP_ADM_1000",
                      displayName: "Hospitalization Rate",
                      format: "rate",
                      unit: 1e3,
                    },
                    {
                      code: "READMIT_RATE",
                      displayName: "Readmission Rate",
                      format: "percent",
                    },
                    {
                      code: "IP_DAYS_PMPY",
                      displayName: "Hospital Days",
                      format: "integer",
                    },
                  ],
                  a =
                    "Commercial" === e.liveInsurance
                      ? t.filter((e) => "MORTALITY_PCT" !== e.code)
                      : t;
                return a;
              },
              populationCodes(e) {
                return "Medicare FFS" == e.liveInsurance
                  ? [
                      { code: "total", displayName: "Total" },
                      { code: "black", displayName: "Black" },
                      { code: "white", displayName: "White" },
                      { code: "hispanic", displayName: "Hispanic" },
                      { code: "male", displayName: "Male" },
                      { code: "female", displayName: "Female" },
                    ]
                  : [
                      { code: "total", displayName: "Total" },
                      { code: "male", displayName: "Male" },
                      { code: "female", displayName: "Female" },
                      { code: "age_band_0_17", displayName: "Ages 0 to 17" },
                      { code: "age_band_18_29", displayName: "Ages 18 to 29" },
                      { code: "age_band_30_49", displayName: "Ages 30 to 49" },
                      { code: "age_band_50_64", displayName: "Ages 50 to 64" },
                      { code: "age_band_65plus", displayName: "Ages 65+" },
                    ];
              },
              currentFormat(e) {
                const t = g(e.liveMetric, this.metricCodes);
                return t;
              },
              currentSettings(e) {
                return {
                  spatial: e.liveSpatialStr,
                  condition: e.liveCondition,
                  comorb1: e.liveComorb1,
                  comorb2: e.liveComorb2,
                  comorb3: e.liveComorb3,
                  metric: e.liveMetric,
                  population: e.livePopulation,
                  year: e.liveYear,
                  insurance: e.liveInsurance,
                };
              },
              settingsHaveChanged(e) {
                const t = JSON.stringify(e.staticSettings),
                  a = JSON.stringify(this.currentSettings);
                return t != a;
              },
              comorb1Codes(e) {
                const t = f(e.liveCondition, e.conditionCodes);
                return C(t);
              },
              comorb2Codes(e) {
                const t = f(e.liveCondition, e.conditionCodes),
                  a = f(e.liveComorb1, this.comorb1Codes);
                return L(t, a);
              },
              showingComorb1(e) {
                let t,
                  a = !1;
                return (
                  (t = e.conditionCodes.filter(
                    (t) => e.liveCondition == t.displayName
                  )),
                  t[0].showDD && (a = !0),
                  (this.liveComorb1 = ""),
                  a
                );
              },
              showingComorb2(e) {
                let t = !1;
                const a = this.comorb1Codes.filter(
                  (t) => e.liveComorb1 == t.displayName
                );
                try {
                  a[0].showDD && (t = !0);
                } catch (o) {
                  t = !1;
                }
                return (this.liveComorb2 = ""), t;
              },
              showingComorb3(e) {
                let t = !1;
                const a = this.comorb2Codes.filter(
                  (t) => e.liveComorb2 == t.displayName
                );
                try {
                  a[0].showDD && (t = !0);
                } catch (o) {
                  t = !1;
                }
                return (this.liveComorb3 = ""), t;
              },
              selectedComorbCount(e) {
                const t = f(e.liveComorb1, e.conditionCodes).length > 0 ? 1 : 0,
                  a = f(e.liveComorb2, e.conditionCodes).length > 0 ? 1 : 0,
                  o = f(e.liveComorb3, e.conditionCodes).length > 0 ? 1 : 0;
                return 0 + t + a + o;
              },
              currentDataTag(e) {
                const t = f(e.liveComorb1, e.conditionCodes),
                  a = f(e.liveComorb2, e.conditionCodes),
                  o = f(e.liveComorb3, e.conditionCodes),
                  i = [t, a, o],
                  s = T(
                    this.selectedComorbCount,
                    f(e.liveCondition, e.conditionCodes),
                    i
                  );
                return s;
              },
              selectMax(e) {
                return "single" == e.selectMode
                  ? 100
                  : "multi" == e.selectMode
                  ? 10
                  : 2;
              },
              getDataBounds(e) {
                const t = e.liveData.map(function (e) {
                    return e.metric;
                  }),
                  a = Math.min(...t),
                  o = Math.max(...t);
                return { min: a, max: o };
              },
            },
            actions: {
              resetFiltersDefaults() {
                (this.liveSpatialStr = "State"),
                  (this.liveCondition = "Type 2 diabetes"),
                  (this.livePopulation = "Total"),
                  (this.liveYear = this.yearsList[4]),
                  (this.liveMetric = "Prevalence"),
                  (this.liveInsurance = "Medicare FFS"),
                  (this.liveComorb1 = ""),
                  (this.liveComorb2 = ""),
                  (this.liveComorb3 = ""),
                  (this.selectMode = "single");
              },
              updateStaticSettings() {
                this.staticSettings = {
                  spatial: this.currentSettings.spatial,
                  condition: this.currentSettings.condition,
                  comorb1: this.currentSettings.comorb1,
                  comorb2: this.currentSettings.comorb2,
                  comorb3: this.currentSettings.comorb3,
                  metric: this.currentSettings.metric,
                  population: this.currentSettings.population,
                  year: this.currentSettings.year,
                  insurance: this.currentSettings.insurance,
                };
                const e = R();
                e.liveNames =
                  "State" === this.liveSpatialStr
                    ? e.stateNames
                    : e.countyNames;
              },
              formatFIPS(e) {
                let t;
                return (
                  (t =
                    "State" === this.liveSpatialStr
                      ? String(Math.floor(e)).padStart(2, "0")
                      : String(Math.floor(e)).padStart(5, "0")),
                  "Commercial" == this.liveInsurance &&
                    "State" === this.liveSpatialStr &&
                    (t = x(e)),
                  t
                );
              },
              formatIncomingMapData(e) {
                const t = f(this.liveMetric, this.metricCodes),
                  a =
                    "State" === this.liveSpatialStr
                      ? "MEM_STATE"
                      : "MEM_COUNTY_FIPS",
                  o = g(this.liveMetric, this.metricCodes),
                  i = e.map((e) => {
                    const { [t]: i, [a]: s } = e;
                    return { metric: M(i, o), id: this.formatFIPS(s) };
                  }),
                  s = new Set([
                    "00",
                    "99",
                    "52",
                    "43",
                    "14",
                    "07",
                    "03",
                    "11",
                    "70",
                    "68",
                    "64",
                    "74",
                    "95",
                    "89",
                    "86",
                    "84",
                    "81",
                    "79",
                    "76",
                    "71",
                    "67",
                    "78",
                    "72",
                    "69",
                    "66",
                    "60",
                  ]),
                  d = i.filter((e) => !s.has(e.id));
                return d;
              },
              async fetchMapData(e) {
                this.dataLoading = !0;
                const t = "State" === this.liveSpatialStr ? "state" : "county",
                  a = `RPL_THEMES_AVG,${f(this.liveMetric, this.metricCodes)}`,
                  o = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.bearToken,
                  },
                  i =
                    this.baseApiUrl +
                    "mapData?" +
                    new URLSearchParams({
                      cond: this.currentDataTag,
                      year: this.liveYear,
                      insr: f(this.liveInsurance, this.liveInsuranceCodes),
                      pop: f(this.livePopulation, this.populationCodes),
                      metric: a,
                      per_page: 1e3,
                      page: 1,
                      geoLevel: t,
                    });
                let s = await fetch(i, { headers: o });
                if (s.ok) {
                  let e = await s.json();
                  const a = e.pagination.last_page;
                  let i = [...this.formatIncomingMapData(e.data)];
                  if (a > 1)
                    for (let s = 2; s <= a; s++) {
                      let e =
                          this.baseApiUrl +
                          "mapData?" +
                          new URLSearchParams({
                            cond: this.currentDataTag,
                            year: this.liveYear,
                            insr: f(
                              this.liveInsurance,
                              this.liveInsuranceCodes
                            ),
                            pop: f(this.livePopulation, this.populationCodes),
                            metric: f(this.liveMetric, this.metricCodes),
                            per_page: 1e3,
                            page: s,
                            geoLevel: t,
                          }),
                        a = await fetch(e, { headers: o }),
                        d = await a.json();
                      i.push(...this.formatIncomingMapData(d.data));
                    }
                  (this.dataLoading = !1),
                    (this.liveData = i),
                    this.updateStaticSettings();
                } else alert(s);
                if (!e) {
                  const e = document.getElementById("collapseSection");
                  e && e.classList.toggle("show");
                }
              },
              async fetchNationData() {
                const e = `RPL_THEMES_AVG,${f(
                    this.liveMetric,
                    this.metricCodes
                  )}`,
                  t =
                    this.baseApiUrl +
                    "mapData?" +
                    new URLSearchParams({
                      cond: this.currentDataTag,
                      year: this.liveYear,
                      insr: f(this.liveInsurance, this.liveInsuranceCodes),
                      pop: f(this.livePopulation, this.populationCodes),
                      metric: e,
                      per_page: 1e3,
                      page: 1,
                      geoLevel: "nation",
                    }),
                  a = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.bearToken,
                  };
                let o = await fetch(t, { headers: a }),
                  i = await o.json();
                const s = g(this.liveMetric, this.metricCodes);
                this.liveNationMap = M(
                  i.data[0][f(this.liveMetric, this.metricCodes)],
                  s
                );
              },
              async fetchCurrentYears() {
                const e = P(),
                  t = new URLSearchParams({
                    cond: "t2d_x_flag",
                    insr: "MedicareFFS",
                    pop: "total",
                    geoLevel: "nation",
                    per_page: 1e3,
                  }),
                  a = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: this.bearToken,
                  },
                  o = this.baseApiUrl + "chartData?" + t;
                let i = await fetch(o, { headers: a });
                if (i.ok) {
                  let t = await i.json();
                  const a = t.data
                    .map((e) => e.YEAR)
                    .sort()
                    .slice(-5);
                  (this.yearsList = a),
                    (this.liveYear = a[4]),
                    (e.yearOptions = a),
                    (e.liveCostYear = a[4]),
                    (e.liveMortYear = a[4]),
                    (this.isApiIssue = !1);
                } else (this.isApiIssue = !0), alert("Issue getting data");
              },
            },
          }),
          F = (e) => ((0, n.Qi)("data-v-bc43686a"), (e = e()), (0, n.jt)(), e),
          H = { class: "dd-brand", for: "dd-choose" },
          Y = ["value"],
          W = F(() =>
            (0, n.Lk)(
              "svg",
              { class: "dd-arrow" },
              [(0, n.Lk)("use", { "xlink:href": "#dd-arrow-down" })],
              -1
            )
          ),
          V = F(() =>
            (0, n.Lk)(
              "svg",
              { class: "dd-arrow1" },
              [
                (0, n.Lk)(
                  "symbol",
                  { id: "dd-arrow-down", viewbox: "0 0 10 6" },
                  [(0, n.Lk)("polyline", { points: "1,1 5,5 9,1" })]
                ),
              ],
              -1
            )
          );
        var j = (0, n.pM)({
          __name: "dropdown-geo",
          setup(e) {
            const t = O();
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("label", H, [
                    (0, n.bo)(
                      (0, n.Lk)(
                        "select",
                        {
                          "onUpdate:modelValue":
                            a[0] ||
                            (a[0] = (e) => ((0, c.R1)(t).liveSpatialStr = e)),
                          class: "dd-choose",
                          id: "dd-condition",
                        },
                        [
                          ((0, n.uX)(!0),
                          (0, n.CE)(
                            n.FK,
                            null,
                            (0, n.pI)(
                              (0, c.R1)(t).spatialOptionsStr,
                              (e) => (
                                (0, n.uX)(),
                                (0, n.CE)(
                                  "option",
                                  { value: e },
                                  (0, h.v_)(e),
                                  9,
                                  Y
                                )
                              )
                            ),
                            256
                          )),
                        ],
                        512
                      ),
                      [[o.u1, (0, c.R1)(t).liveSpatialStr]]
                    ),
                    W,
                  ]),
                  V,
                ],
                64
              )
            );
          },
        });
        const B = (0, u.A)(j, [["__scopeId", "data-v-bc43686a"]]);
        var $ = B;
        const X = (e) => (
            (0, n.Qi)("data-v-35febfe9"), (e = e()), (0, n.jt)(), e
          ),
          U = { class: "dd-brand", for: "dd-choose" },
          G = ["value"],
          z = X(() =>
            (0, n.Lk)(
              "svg",
              { class: "dd-arrow" },
              [(0, n.Lk)("use", { "xlink:href": "#dd-arrow-down" })],
              -1
            )
          ),
          K = X(() =>
            (0, n.Lk)(
              "svg",
              { class: "dd-arrow1" },
              [
                (0, n.Lk)(
                  "symbol",
                  { id: "dd-arrow-down", viewbox: "0 0 10 6" },
                  [(0, n.Lk)("polyline", { points: "1,1 5,5 9,1" })]
                ),
              ],
              -1
            )
          );
        var Q = (0, n.pM)({
          __name: "dropdown-brand",
          props: {
            idStr: { default: "Placeholder ID" },
            vModelVar: { default: "Empty" },
            optionList: { default: () => ["Option 1", "Option 2", "Option 3"] },
            storeName: { default: "options" },
          },
          setup(e) {
            const t = e;
            let a;
            "spatial" == t.storeName
              ? (a = R())
              : "modal" == t.storeName
              ? (a = P())
              : "options" == t.storeName && (a = O());
            const i = (0, n.EW)({
              get() {
                return a[t.vModelVar];
              },
              set(e) {
                a[t.vModelVar] = e;
              },
            });
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("label", U, [
                    (0, n.bo)(
                      (0, n.Lk)(
                        "select",
                        {
                          "onUpdate:modelValue":
                            a[0] || (a[0] = (e) => (i.value = e)),
                          class: "dd-choose",
                          id: "dd-condition",
                        },
                        [
                          ((0, n.uX)(!0),
                          (0, n.CE)(
                            n.FK,
                            null,
                            (0, n.pI)(
                              t.optionList,
                              (e) => (
                                (0, n.uX)(),
                                (0, n.CE)(
                                  "option",
                                  { value: e },
                                  (0, h.v_)(e),
                                  9,
                                  G
                                )
                              )
                            ),
                            256
                          )),
                        ],
                        512
                      ),
                      [[o.u1, i.value]]
                    ),
                    z,
                  ]),
                  K,
                ],
                64
              )
            );
          },
        });
        const q = (0, u.A)(Q, [["__scopeId", "data-v-35febfe9"]]);
        var Z = q;
        const J = { class: "radio-group" },
          ee = ["id", "value"],
          te = ["for"];
        var ae = (0, n.pM)({
          __name: "year-radio-brand",
          props: {
            idStr: { default: "Placeholder ID" },
            vModelVar: { default: "Empty" },
            optionList: { default: () => ["Option 1", "Option 2", "Option 3"] },
          },
          setup(e) {
            const t = O(),
              a = e,
              i = (0, n.EW)({
                get() {
                  return t[a.vModelVar];
                },
                set(e) {
                  t[a.vModelVar] = e;
                },
              });
            return (e, t) => (
              (0, n.uX)(),
              (0, n.CE)("div", J, [
                ((0, n.uX)(!0),
                (0, n.CE)(
                  n.FK,
                  null,
                  (0, n.pI)(
                    a.optionList,
                    (e, s) => (
                      (0, n.uX)(),
                      (0, n.CE)("div", { key: s, class: "form-check" }, [
                        (0, n.bo)(
                          (0, n.Lk)(
                            "input",
                            {
                              class: "form-check-input",
                              type: "radio",
                              id: a.idStr + s,
                              value: e,
                              "onUpdate:modelValue":
                                t[0] || (t[0] = (e) => (i.value = e)),
                            },
                            null,
                            8,
                            ee
                          ),
                          [[o.XL, i.value]]
                        ),
                        (0, n.Lk)(
                          "label",
                          {
                            class: "form-check-label text-white",
                            for: a.idStr + s,
                          },
                          (0, h.v_)(e),
                          9,
                          te
                        ),
                      ])
                    )
                  ),
                  128
                )),
              ])
            );
          },
        });
        const oe = (0, u.A)(ae, [["__scopeId", "data-v-16f318df"]]);
        var ie = oe;
        const se = (e) => (
            (0, n.Qi)("data-v-333b017d"), (e = e()), (0, n.jt)(), e
          ),
          de = { class: "row justify-content-center mont-font" },
          ne = { class: "col-11" },
          ce = { class: "accordion shadow", id: "filterAccordian" },
          re = { class: "accordion-item" },
          le = se(() =>
            (0, n.Lk)(
              "div",
              { class: "accordion-header" },
              [
                (0, n.Lk)(
                  "button",
                  {
                    class: "accordion-button p-3 fs-5 collapsed bg-primary",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#collapseSection",
                  },
                  [
                    (0, n.Lk)(
                      "div",
                      { class: "btn-text" },
                      " Options and Filters "
                    ),
                  ]
                ),
              ],
              -1
            )
          ),
          me = {
            id: "collapseSection",
            class: "accordion-collapse collapse bg-primary",
            "data-bs-parent": "#filterAccordian",
          },
          pe = { class: "accordion-body" },
          ue = { class: "row" },
          _e = { class: "col-6" },
          be = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-4 text-white" },
              "Index Condition",
              -1
            )
          ),
          ve = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select a condition from the dropdown to act as an index disease. Based on the selection, subsequent comorbitity options will appear. ",
              -1
            )
          ),
          he = { class: "pt-2" },
          ye = { class: "col-6" },
          ke = se(() =>
            (0, n.Lk)("div", { class: "fs-4 text-white" }, "Comorbidities", -1)
          ),
          fe = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Up to three comorbidities can be selected based on the condition and prior comorbidity selections. ",
              -1
            )
          ),
          ge = { class: "pt-2 d-flex flex-wrap" },
          Ce = { class: "pe-4 pt-1" },
          Le = se(() =>
            (0, n.Lk)("div", { class: "text-white fs-6" }, "Comorbidity 1", -1)
          ),
          De = { class: "pe-4 pt-1" },
          we = se(() =>
            (0, n.Lk)("div", { class: "text-white fs-6" }, "Comorbidity 2", -1)
          ),
          Te = { class: "pt-1" },
          Ne = se(() =>
            (0, n.Lk)("div", { class: "text-white fs-6" }, "Comorbidity 3", -1)
          ),
          Me = { class: "row pt-4" },
          Ae = { class: "col-6" },
          Se = se(() =>
            (0, n.Lk)("div", { class: "fs-4 text-white" }, "Geography", -1)
          ),
          Ee = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select a unit of geography to display on the map. ",
              -1
            )
          ),
          Ie = { class: "pt-2" },
          xe = { class: "col-6" },
          Re = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-4 text-white" },
              "Demographic subgroups",
              -1
            )
          ),
          Pe = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select the demographic group to display. ",
              -1
            )
          ),
          Oe = { class: "pt-2" },
          Fe = { class: "row pt-4" },
          He = { class: "col-6" },
          Ye = se(() =>
            (0, n.Lk)("div", { class: "fs-4 text-white" }, "Year", -1)
          ),
          We = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select the year of data collection for the map display. ",
              -1
            )
          ),
          Ve = { class: "pt-2" },
          je = { class: "col-6" },
          Be = se(() =>
            (0, n.Lk)("div", { class: "fs-4 text-white" }, "Metric", -1)
          ),
          $e = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select the metric to show as a color gradient on the map.",
              -1
            )
          ),
          Xe = { class: "pt-2" },
          Ue = { class: "row pt-4" },
          Ge = { class: "col-6" },
          ze = se(() =>
            (0, n.Lk)("div", { class: "fs-4 text-white" }, "Insurance Type", -1)
          ),
          Ke = se(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-6 text-white pt-2" },
              "Select the type of coverage for the population ",
              -1
            )
          ),
          Qe = { class: "pt-2" },
          qe = { class: "row pt-4 text-white justify-content-center" },
          Ze = { class: "col-2" },
          Je = { class: "col-2" };
        var et = (0, n.pM)({
          __name: "filter-accordian",
          setup(e) {
            const t = O(),
              a = R();
            function i() {
              if (
                "Commercial" == t.liveInsurance &&
                "County" == t.liveSpatialStr
              )
                return void alert("Missing insurance selection!");
              const e = ["Black", "White", "Hispanic"];
              if (
                "Commercial" == t.liveInsurance &&
                e.includes(t.livePopulation)
              )
                return void alert("Missing demographic selection!");
              if (
                "Medicare FFS" == t.liveInsurance &&
                t.livePopulation.includes("Ages")
              )
                return void alert("Missing demographic selection!");
              const o = document.getElementById("draggable");
              (o.style.display = "none"),
                a.clearMultiSelect(),
                (t.selectMode = "single"),
                t.fetchMapData(!1);
            }
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)("div", de, [
                (0, n.Lk)("div", ne, [
                  (0, n.Lk)("div", ce, [
                    (0, n.Lk)("div", re, [
                      le,
                      (0, n.Lk)("div", me, [
                        (0, n.Lk)("div", pe, [
                          (0, n.Lk)("div", ue, [
                            (0, n.Lk)("div", _e, [
                              be,
                              ve,
                              (0, n.Lk)("div", he, [
                                (0, n.bF)(
                                  Z,
                                  {
                                    idStr: "condition-dd",
                                    vModelVar: "liveCondition",
                                    optionList: (0, c.R1)(t).conditionCodes.map(
                                      (e) => e.displayName
                                    ),
                                  },
                                  null,
                                  8,
                                  ["optionList"]
                                ),
                              ]),
                            ]),
                            (0, n.Lk)("div", ye, [
                              ke,
                              fe,
                              (0, n.Lk)("div", ge, [
                                (0, n.bo)(
                                  (0, n.Lk)(
                                    "div",
                                    Ce,
                                    [
                                      Le,
                                      (0, n.bF)(
                                        Z,
                                        {
                                          vModelVar: "liveComorb1",
                                          idStr: "coMorb1-dd",
                                          optionList: (0, c.R1)(
                                            t
                                          ).comorb1Codes.map(
                                            (e) => e.displayName
                                          ),
                                        },
                                        null,
                                        8,
                                        ["optionList"]
                                      ),
                                    ],
                                    512
                                  ),
                                  [[o.aG, (0, c.R1)(t).showingComorb1]]
                                ),
                                (0, n.bo)(
                                  (0, n.Lk)(
                                    "div",
                                    De,
                                    [
                                      we,
                                      (0, n.bF)(
                                        Z,
                                        {
                                          vModelVar: "liveComorb2",
                                          idStr: "coMorb2-dd",
                                          optionList: (0, c.R1)(
                                            t
                                          ).comorb2Codes.map(
                                            (e) => e.displayName
                                          ),
                                        },
                                        null,
                                        8,
                                        ["optionList"]
                                      ),
                                    ],
                                    512
                                  ),
                                  [[o.aG, (0, c.R1)(t).showingComorb2]]
                                ),
                                (0, n.bo)(
                                  (0, n.Lk)(
                                    "div",
                                    Te,
                                    [
                                      Ne,
                                      (0, n.bF)(
                                        Z,
                                        {
                                          vModelVar: "liveComorb3",
                                          idStr: "coMorb3-dd",
                                          optionList: (0, c.R1)(
                                            t
                                          ).comorb3Codes.map(
                                            (e) => e.displayName
                                          ),
                                        },
                                        null,
                                        8,
                                        ["optionList"]
                                      ),
                                    ],
                                    512
                                  ),
                                  [[o.aG, (0, c.R1)(t).showingComorb3]]
                                ),
                              ]),
                            ]),
                          ]),
                          (0, n.Lk)("div", Me, [
                            (0, n.Lk)("div", Ae, [
                              Se,
                              Ee,
                              (0, n.Lk)("div", Ie, [(0, n.bF)($)]),
                            ]),
                            (0, n.Lk)("div", xe, [
                              Re,
                              Pe,
                              (0, n.Lk)("div", Oe, [
                                (0, n.bF)(
                                  Z,
                                  {
                                    idStr: "population-dd",
                                    vModelVar: "livePopulation",
                                    optionList: (0, c.R1)(
                                      t
                                    ).populationCodes.map((e) => e.displayName),
                                  },
                                  null,
                                  8,
                                  ["optionList"]
                                ),
                              ]),
                            ]),
                          ]),
                          (0, n.Lk)("div", Fe, [
                            (0, n.Lk)("div", He, [
                              Ye,
                              We,
                              (0, n.Lk)("div", Ve, [
                                (0, n.bF)(
                                  ie,
                                  {
                                    vModelVar: "liveYear",
                                    optionList: (0, c.R1)(t).yearsList,
                                    idStr: "yearSelect",
                                  },
                                  null,
                                  8,
                                  ["optionList"]
                                ),
                              ]),
                            ]),
                            (0, n.Lk)("div", je, [
                              Be,
                              $e,
                              (0, n.Lk)("div", Xe, [
                                (0, n.bF)(
                                  Z,
                                  {
                                    idStr: "metric-dd",
                                    vModelVar: "liveMetric",
                                    optionList: (0, c.R1)(t).metricCodes.map(
                                      (e) => e.displayName
                                    ),
                                  },
                                  null,
                                  8,
                                  ["optionList"]
                                ),
                              ]),
                            ]),
                          ]),
                          (0, n.Lk)("div", Ue, [
                            (0, n.Lk)("div", Ge, [
                              ze,
                              Ke,
                              (0, n.Lk)("div", Qe, [
                                (0, n.bF)(
                                  Z,
                                  {
                                    idStr: "population-dd",
                                    vModelVar: "liveInsurance",
                                    optionList: (0, c.R1)(
                                      t
                                    ).liveInsuranceCodes.map(
                                      (e) => e.displayName
                                    ),
                                  },
                                  null,
                                  8,
                                  ["optionList"]
                                ),
                              ]),
                            ]),
                          ]),
                          (0, n.Lk)("div", qe, [
                            (0, n.Lk)("div", Ze, [
                              (0, n.Lk)(
                                "button",
                                {
                                  onClick: a[0] || (a[0] = (e) => i()),
                                  class: (0, h.C4)([
                                    "btn btn-light",
                                    {
                                      "pulse-button": (0, c.R1)(t)
                                        .settingsHaveChanged,
                                    },
                                  ]),
                                },
                                "Update Map",
                                2
                              ),
                            ]),
                            (0, n.Lk)("div", Je, [
                              (0, n.Lk)(
                                "button",
                                {
                                  onClick:
                                    a[1] ||
                                    (a[1] = (e) =>
                                      (0, c.R1)(t).resetFiltersDefaults()),
                                  class: "btn btn-secondary",
                                },
                                "Restore Defaults"
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            );
          },
        });
        const tt = (0, u.A)(et, [["__scopeId", "data-v-333b017d"]]);
        var at = tt,
          ot = a(5524),
          it = a(1010);
        const st = { class: "dropdowns d-flex justify-content-evenly py-2" };
        var dt = (0, n.pM)({
          __name: "hosp-rate",
          setup(e) {
            ot.t1.register(ot.PP, ot.kc, ot.FN, ot.No, ot.hE, ot.m_, ot.s$);
            const t = P(),
              a = O(),
              o = (0, n.EW)(() => {
                const e = f(t.liveHospType, a.metricCodes);
                try {
                  const a = "Readmission Rate" == t.liveHospType ? 100 : 1,
                    o = t.liveModalData.data
                      .sort((e, t) => e.YEAR - t.YEAR)
                      .slice(-5),
                    i = o.map((t) => parseFloat(t[e] * a));
                  return i;
                } catch (o) {
                  return [0];
                }
              }),
              i = (0, n.EW)(() => {
                const e = f(t.liveHospType, a.metricCodes);
                try {
                  const a = "Readmission Rate" == t.liveHospType ? 100 : 1,
                    o = t.liveModalNation.data
                      .sort((e, t) => e.YEAR - t.YEAR)
                      .slice(-5),
                    i = o.map((t) => parseFloat(t[e] * a));
                  return i;
                } catch (o) {
                  return [0];
                }
              }),
              s = (0, n.EW)(() => {
                switch (t.liveHospType) {
                  case "Hospitalization Rate":
                    return "Hospitalization Rate per 1000";
                  case "Readmission Rate":
                    return "Readmission Rate";
                  case "Hospital Days":
                    return "Days";
                  default:
                    break;
                }
              });
            function d(e) {
              switch (t.liveHospType) {
                case "Hospitalization Rate":
                  return e;
                case "Readmission Rate":
                  return e.toFixed(1) + "%";
                case "Hospital Days":
                  return e.toFixed(1);
                default:
                  break;
              }
            }
            const r = (0, n.EW)(() => {
                switch (t.liveHospType) {
                  case "Hospitalization Rate":
                    return " per 1000";
                  case "Readmission Rate":
                    return "%";
                  case "Hospital Days":
                    return " days";
                  default:
                    break;
                }
              }),
              l = (0, n.EW)(() => ({
                labels: a.yearsList,
                datasets: [
                  {
                    label: t.legendItems1,
                    backgroundColor: "#08312A",
                    borderColor: "#08312A",
                    data: o.value,
                    tension: 0.1,
                    pointRadius: 5,
                  },
                  {
                    label: t.legendItems2,
                    backgroundColor: "#00E47C",
                    borderColor: "#00E47C",
                    data: i.value,
                    tension: 0.1,
                    pointRadius: 5,
                  },
                ],
              })),
              m = (0, n.EW)(() => ({
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (e) {
                        return (
                          e.dataset.label +
                          ": " +
                          e.parsed.y.toFixed(1) +
                          r.value
                        );
                      },
                    },
                  },
                },
                responsive: !0,
                maintainAspectRatio: !0,
                pointRadius: 0,
                scales: {
                  x: {
                    grid: { display: !1 },
                    title: { display: !0, text: "Year", color: "black" },
                  },
                  y: {
                    beginAtZero: !0,
                    grid: { display: !1 },
                    ticks: {
                      callback: function (e) {
                        return d(e);
                      },
                    },
                    title: { display: !0, text: s.value, color: "black" },
                  },
                },
              }));
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("div", st, [
                    (0, n.bF)(
                      Z,
                      {
                        idStr: "hosp-dd",
                        storeName: "modal",
                        vModelVar: "liveHospType",
                        optionList: (0, c.R1)(t).hospTypeOptions,
                      },
                      null,
                      8,
                      ["optionList"]
                    ),
                  ]),
                  (0, n.bF)(
                    (0, c.R1)(it.N1),
                    { data: l.value, options: m.value },
                    null,
                    8,
                    ["data", "options"]
                  ),
                ],
                64
              )
            );
          },
        });
        const nt = dt;
        var ct = nt;
        const rt = { class: "dropdowns d-flex justify-content-evenly py-2" };
        var lt = (0, n.pM)({
          __name: "healthcare-costs",
          setup(e) {
            ot.t1.register(ot.PP, ot.kc, ot.E8, ot.hE, ot.m_, ot.s$);
            const t = P(),
              a = O(),
              o = (0, n.EW)(() => {
                try {
                  const e = t.liveModalData.data.filter(
                      (e) => e.YEAR == t.liveCostYear
                    ),
                    a = e.map((e) => parseFloat(e.TOTAL_ALLOW)),
                    o = e.map((e) => parseFloat(e.IP_ALLOW)),
                    i = e.map((e) => parseFloat(e.PAC_ALLOW));
                  return [a, o, i];
                } catch (e) {
                  return [0];
                }
              }),
              i = (0, n.EW)(() => {
                try {
                  const e = t.liveModalNation.data.filter(
                      (e) => e.YEAR == t.liveCostYear
                    ),
                    a = e.map((e) => parseFloat(e.TOTAL_ALLOW)),
                    o = e.map((e) => parseFloat(e.IP_ALLOW)),
                    i = e.map((e) => parseFloat(e.PAC_ALLOW));
                  return [a, o, i];
                } catch (e) {
                  return [0];
                }
              }),
              s = (0, n.EW)(() => ({
                labels: [
                  "All-Cause Cost",
                  "Inpatient Cost",
                  "Post-Acute Care Cost",
                ],
                datasets: [
                  {
                    label: t.legendItems1,
                    backgroundColor: "#08312A",
                    data: o.value,
                    barPercentage: 0.6,
                  },
                  ...("comp" == a.selectMode
                    ? [
                        {
                          label: t.legendItems2,
                          backgroundColor: "#00E47C",
                          data: i.value,
                          barPercentage: 0.6,
                        },
                      ]
                    : []),
                ],
              })),
              d = {
                responsive: !0,
                maintainAspectRatio: !0,
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (e) {
                        return e.parsed.y.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        });
                      },
                    },
                  },
                },
                scales: {
                  x: { grid: { display: !1 }, title: { display: !1 } },
                  y: {
                    min: 0,
                    grid: { display: !1 },
                    ticks: {
                      callback: function (e) {
                        return e.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        });
                      },
                    },
                    title: { display: !0, text: "Cost (USD)", color: "black" },
                  },
                },
              };
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("div", rt, [
                    (0, n.bF)(
                      Z,
                      {
                        idStr: "costYear-dd",
                        storeName: "modal",
                        vModelVar: "liveCostYear",
                        optionList: (0, c.R1)(t).yearOptions,
                      },
                      null,
                      8,
                      ["optionList"]
                    ),
                  ]),
                  (0, n.bF)(
                    (0, c.R1)(it.yP),
                    { data: s.value, options: d },
                    null,
                    8,
                    ["data"]
                  ),
                ],
                64
              )
            );
          },
        });
        const mt = lt;
        var pt = mt,
          ut = {
            __name: "disease-prev",
            setup(e) {
              ot.t1.register(ot.PP, ot.kc, ot.FN, ot.No, ot.hE, ot.m_, ot.s$);
              const t = P(),
                a = O(),
                i = (0, n.EW)(() => {
                  try {
                    const e = t.liveModalData.data
                        .sort((e, t) => e.YEAR - t.YEAR)
                        .slice(-5),
                      a = e.map((e) => parseFloat(100 * e.PREV));
                    return a;
                  } catch (e) {
                    return [0];
                  }
                }),
                s = (0, n.EW)(() => {
                  try {
                    const e = t.liveModalNation.data
                        .sort((e, t) => e.YEAR - t.YEAR)
                        .slice(-5),
                      a = e.map((e) => parseFloat(100 * e.PREV));
                    return a;
                  } catch (e) {
                    return [0];
                  }
                }),
                d = (0, n.EW)(() => Math.max(...i.value)),
                r = (0, n.EW)(() => ({
                  labels: a.yearsList,
                  datasets: [
                    {
                      label: t.legendItems1,
                      backgroundColor: "#08312A",
                      borderColor: "#08312A",
                      data: i.value,
                      tension: 0.1,
                      pointRadius: 5,
                    },
                    {
                      label: t.legendItems2,
                      backgroundColor: "#00E47C",
                      borderColor: "#00E47C",
                      data: s.value,
                      tension: 0.1,
                      pointRadius: 5,
                    },
                  ],
                })),
                l = {
                  plugins: {
                    tooltip: {
                      callbacks: {
                        label: function (e) {
                          return (
                            e.dataset.label + ": " + e.parsed.y.toFixed(1) + "%"
                          );
                        },
                      },
                    },
                  },
                  responsive: !0,
                  maintainAspectRatio: !0,
                  pointRadius: 0,
                  scales: {
                    x: {
                      grid: { display: !1 },
                      title: { display: !0, text: "Year", color: "black" },
                    },
                    y: {
                      beginAtZero: !0,
                      grid: { display: !1 },
                      ticks: {
                        callback: function (e) {
                          return d.value <= 20
                            ? e.toFixed(1) + "%"
                            : e.toFixed(0) + "%";
                        },
                      },
                      title: {
                        display: !0,
                        text: "Prevalence",
                        color: "black",
                      },
                    },
                  },
                };
              return (e, a) => (
                (0, n.uX)(),
                (0, n.CE)(
                  n.FK,
                  null,
                  [
                    (0, n.bo)(
                      (0, n.Lk)(
                        "span",
                        null,
                        (0, h.v_)((0, c.R1)(t).nestedTrigger),
                        513
                      ),
                      [[o.aG, !1]]
                    ),
                    (0, n.bF)(
                      (0, c.R1)(it.N1),
                      { data: r.value, options: l },
                      null,
                      8,
                      ["data"]
                    ),
                  ],
                  64
                )
              );
            },
          };
        const _t = ut;
        var bt = _t,
          vt = {
            __name: "mortality-rate-bar",
            setup(e) {
              ot.t1.register(ot.PP, ot.kc, ot.E8, ot.hE, ot.m_, ot.s$);
              const t = P(),
                a = (0, n.EW)(() => {
                  try {
                    const e =
                        100 *
                        parseFloat(
                          t.liveModalData.data.filter(
                            (e) => e.YEAR == t.liveMortYear
                          )[0].MORTALITY_PCT
                        ),
                      a =
                        100 *
                        parseFloat(
                          t.liveModalNation.data.filter(
                            (e) => e.YEAR == t.liveMortYear
                          )[0].MORTALITY_PCT
                        );
                    return [e, a];
                  } catch (e) {
                    return 0;
                  }
                }),
                o = (0, n.EW)(() => ({
                  labels: [t.legendItems1, t.legendItems2],
                  datasets: [
                    {
                      label: "Mortality",
                      backgroundColor: "#08312A",
                      data: a.value,
                      barPercentage: 0.4,
                    },
                  ],
                })),
                i = {
                  responsive: !0,
                  maintainAspectRatio: !0,
                  plugins: {
                    tooltip: {
                      callbacks: {
                        label: function (e) {
                          return e.parsed.y.toFixed(1) + "%";
                        },
                      },
                    },
                  },
                  scales: {
                    x: { grid: { display: !1 }, title: { display: !1 } },
                    y: {
                      min: 0,
                      grid: { display: !1 },
                      ticks: {
                        callback: function (e) {
                          return e.toFixed(1) + "%";
                        },
                      },
                      title: {
                        display: !0,
                        text: "Mortality Rate",
                        color: "black",
                      },
                    },
                  },
                };
              return (e, t) => (
                (0, n.uX)(),
                (0, n.Wv)(
                  (0, c.R1)(it.yP),
                  { data: o.value, options: i },
                  null,
                  8,
                  ["data"]
                )
              );
            },
          };
        const ht = vt;
        var yt = ht,
          kt = {
            __name: "mortality-rate-trend",
            setup(e) {
              ot.t1.register(ot.PP, ot.kc, ot.FN, ot.No, ot.hE, ot.m_, ot.s$);
              const t = P(),
                a = O(),
                o = (0, n.EW)(() => {
                  try {
                    const e = t.liveModalData.data
                        .sort((e, t) => e.YEAR - t.YEAR)
                        .slice(-5),
                      a = e.map((e) => parseFloat(100 * e.MORTALITY_PCT));
                    return a;
                  } catch (e) {
                    return [0];
                  }
                }),
                i = (0, n.EW)(() => {
                  try {
                    const e = t.liveModalNation.data
                        .sort((e, t) => e.YEAR - t.YEAR)
                        .slice(-5),
                      a = e.map((e) => parseFloat(100 * e.MORTALITY_PCT));
                    return a;
                  } catch (e) {
                    return [0];
                  }
                }),
                s = (0, n.EW)(() => ({
                  labels: a.yearsList,
                  datasets: [
                    {
                      label: t.legendItems1,
                      backgroundColor: "#08312A",
                      borderColor: "#08312A",
                      data: o.value,
                      tension: 0.1,
                      pointRadius: 5,
                    },
                    {
                      label: t.legendItems2,
                      backgroundColor: "#00E47C",
                      borderColor: "#00E47C",
                      data: i.value,
                      tension: 0.1,
                      pointRadius: 5,
                    },
                  ],
                })),
                d = {
                  plugins: {
                    tooltip: {
                      callbacks: {
                        label: function (e) {
                          return (
                            e.dataset.label + ": " + e.parsed.y.toFixed(1) + "%"
                          );
                        },
                      },
                    },
                  },
                  responsive: !0,
                  maintainAspectRatio: !0,
                  pointRadius: 0,
                  scales: {
                    x: {
                      grid: { display: !1 },
                      title: { display: !0, text: "Year", color: "black" },
                    },
                    y: {
                      beginAtZero: !0,
                      grid: { display: !1 },
                      ticks: {
                        callback: function (e) {
                          return e.toFixed(0) + "%";
                        },
                      },
                      title: {
                        display: !0,
                        text: "Mortality Rate",
                        color: "black",
                      },
                    },
                  },
                };
              return (e, t) => (
                (0, n.uX)(),
                (0, n.Wv)(
                  (0, c.R1)(it.N1),
                  { data: s.value, options: d },
                  null,
                  8,
                  ["data"]
                )
              );
            },
          };
        const ft = kt;
        var gt = ft;
        const Ct = ["for"],
          Lt = ["id"];
        var Dt = (0, n.pM)({
          __name: "toggle-brand",
          props: {
            idStr: { default: "Placeholder ID" },
            vModelVar: { default: "Empty" },
            storeName: { default: "options" },
            select1: { default: "Comparison" },
            select2: { default: "Trend Over Time" },
          },
          setup(e) {
            const t = e;
            let a;
            "spatial" == t.storeName
              ? (a = R())
              : "modal" == t.storeName
              ? (a = P())
              : "options" == t.storeName && (a = O());
            const i = (0, n.EW)({
              get() {
                return a[t.vModelVar];
              },
              set(e) {
                a[t.vModelVar] = e;
              },
            });
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                "label",
                {
                  for: t.idStr,
                  class: "switch",
                  "aria-label": "Toggle Filter",
                },
                [
                  (0, n.bo)(
                    (0, n.Lk)(
                      "input",
                      {
                        "onUpdate:modelValue":
                          a[0] || (a[0] = (e) => (i.value = e)),
                        type: "checkbox",
                        id: t.idStr,
                      },
                      null,
                      8,
                      Lt
                    ),
                    [[o.lH, i.value]]
                  ),
                  (0, n.Lk)("span", null, (0, h.v_)(t.select1), 1),
                  (0, n.Lk)("span", null, (0, h.v_)(t.select2), 1),
                ],
                8,
                Ct
              )
            );
          },
        });
        const wt = (0, u.A)(Dt, [["__scopeId", "data-v-4de0881a"]]);
        var Tt = wt;
        const Nt = { class: "dropdowns d-flex justify-content-evenly py-2" },
          Mt = { class: "dropdowns d-flex justify-content-evenly py-2" };
        var At = (0, n.pM)({
          __name: "mortality-wrapper",
          setup(e) {
            const t = P();
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("div", Nt, [
                    (0, n.bF)(Tt, {
                      idStr: "mortToggle",
                      storeName: "modal",
                      vModelVar: "mortIsTrend",
                      select1: "Comparison",
                      select2: "Trend Over Time",
                    }),
                  ]),
                  (0, n.Lk)("div", Mt, [
                    (0, c.R1)(t).mortIsTrend
                      ? (0, n.Q3)("", !0)
                      : ((0, n.uX)(),
                        (0, n.Wv)(
                          Z,
                          {
                            key: 0,
                            idStr: "mortYear-dd",
                            storeName: "modal",
                            vModelVar: "liveMortYear",
                            optionList: (0, c.R1)(t).yearOptions,
                          },
                          null,
                          8,
                          ["optionList"]
                        )),
                  ]),
                  (0, n.Lk)("div", null, [
                    (0, c.R1)(t).mortIsTrend
                      ? (0, n.Q3)("", !0)
                      : ((0, n.uX)(), (0, n.Wv)(yt, { key: 0 })),
                    (0, c.R1)(t).mortIsTrend
                      ? ((0, n.uX)(), (0, n.Wv)(gt, { key: 1 }))
                      : (0, n.Q3)("", !0),
                  ]),
                ],
                64
              )
            );
          },
        });
        const St = At;
        var Et = St;
        const It = (e) => (
            (0, n.Qi)("data-v-10b2da72"), (e = e()), (0, n.jt)(), e
          ),
          xt = { class: "row text-center d-flex flex-wrap" },
          Rt = { class: "col-lg-3 col-sm-6 py-2" },
          Pt = { class: "card text-center" },
          Ot = { class: "card-body" },
          Ft = { class: "display-5 text-primary" },
          Ht = It(() =>
            (0, n.Lk)("div", { class: "fs-6 fw-bold" }, " Percentile ", -1)
          ),
          Yt = It(() =>
            (0, n.Lk)(
              "div",
              { class: "card-text" },
              "Socioeconomic Status",
              -1
            )
          ),
          Wt = { class: "col-lg-3 col-sm-6 py-2" },
          Vt = { class: "card text-center" },
          jt = { class: "card-body" },
          Bt = { class: "display-5 text-primary" },
          $t = It(() =>
            (0, n.Lk)("div", { class: "fs-6 fw-bold" }, " Percentile ", -1)
          ),
          Xt = It(() =>
            (0, n.Lk)(
              "div",
              { class: "card-text" },
              "Household Characteristics",
              -1
            )
          ),
          Ut = { class: "col-lg-3 col-sm-6 py-2" },
          Gt = { class: "card text-center" },
          zt = { class: "card-body" },
          Kt = { class: "display-5 text-primary" },
          Qt = { class: "display-5 text-primary" },
          qt = It(() =>
            (0, n.Lk)("div", { class: "fs-6 fw-bold" }, " Percentile ", -1)
          ),
          Zt = It(() =>
            (0, n.Lk)(
              "div",
              { class: "card-text" },
              "Race and Ethnicity",
              -1
            )
          ),
          Jt = { class: "col-lg-3 col-sm-6 py-2" },
          ea = { class: "card text-center" },
          ta = { class: "card-body" },
          aa = { class: "display-5 text-primary" },
          oa = { class: "display-5 text-primary" },
          ia = It(() =>
            (0, n.Lk)("div", { class: "fs-6 fw-bold" }, " Percentile ", -1)
          ),
          sa = It(() =>
            (0, n.Lk)(
              "div",
              { class: "card-text" },
              "Housing and Transportation",
              -1
            )
          );
        var da = (0, n.pM)({
          __name: "svi-reports",
          setup(e) {
            const t = P(),
              a = O();
            function o(e) {
              const t = e;
              let a = t % 10,
                o = t % 100;
              return 1 === a && 11 !== o
                ? "st"
                : 2 === a && 12 !== o
                ? "nd"
                : 3 === a && 13 !== o
                ? "rd"
                : "th";
            }
            const i = (0, n.EW)(() => {
              try {
                const e = "State" === a.liveSpatialStr,
                  i = t.liveModalData.data.find((e) => e.YEAR == a.liveYear),
                  s = (e) => {
                    const t = Math.round(100 * parseFloat(i[e]));
                    return t + o(t);
                  };
                return {
                  theme1: s(e ? "RPL_THEME1_AVG" : "RPL_THEME1_IN_STATE_AVG"),
                  theme2: s(e ? "RPL_THEME2_AVG" : "RPL_THEME2_IN_STATE_AVG"),
                  theme3: s(e ? "RPL_THEME3_AVG" : "RPL_THEME3_IN_STATE_AVG"),
                  theme4: s(e ? "RPL_THEME4_AVG" : "RPL_THEME4_IN_STATE_AVG"),
                };
              } catch (e) {
                return {
                  theme1: "Missing",
                  theme2: "Missing",
                  theme3: "Missing",
                  theme4: "Missing",
                };
              }
            });
            return (e, t) => (
              (0, n.uX)(),
              (0, n.CE)("div", xt, [
                (0, n.Lk)("div", Rt, [
                  (0, n.Lk)("div", Pt, [
                    (0, n.Lk)("div", Ot, [
                      (0, n.Lk)("div", Ft, [
                        (0, n.Lk)("div", null, (0, h.v_)(i.value.theme1), 1),
                        Ht,
                      ]),
                      Yt,
                    ]),
                  ]),
                ]),
                (0, n.Lk)("div", Wt, [
                  (0, n.Lk)("div", Vt, [
                    (0, n.Lk)("div", jt, [
                      (0, n.Lk)("div", Bt, [
                        (0, n.Lk)("div", null, (0, h.v_)(i.value.theme2), 1),
                        $t,
                      ]),
                      Xt,
                    ]),
                  ]),
                ]),
                (0, n.Lk)("div", Ut, [
                  (0, n.Lk)("div", Gt, [
                    (0, n.Lk)("div", zt, [
                      (0, n.Lk)("div", Kt, [
                        (0, n.Lk)("div", Qt, [
                          (0, n.Lk)("div", null, (0, h.v_)(i.value.theme3), 1),
                          qt,
                        ]),
                      ]),
                      Zt,
                    ]),
                  ]),
                ]),
                (0, n.Lk)("div", Jt, [
                  (0, n.Lk)("div", ea, [
                    (0, n.Lk)("div", ta, [
                      (0, n.Lk)("div", aa, [
                        (0, n.Lk)("div", oa, [
                          (0, n.Lk)("div", null, (0, h.v_)(i.value.theme4), 1),
                          ia,
                        ]),
                      ]),
                      sa,
                    ]),
                  ]),
                ]),
              ])
            );
          },
        });
        const na = (0, u.A)(da, [["__scopeId", "data-v-10b2da72"]]);
        var ca = na,
          ra = a(1749),
          la = a(2125),
          ma = a.n(la),
          pa = a(5839);
        (0, pa.applyPlugin)(ra.jsPDF);
        const ua = (0, i.nY)("exportStore", {
          state: () => ({
            xStart: 0.25,
            yStart: 1.1,
            sectionHeaderFont: 16,
            headerFont: 14,
            footerFont: 8,
            paragraphFont: 10,
            textWidth: 10.25,
            footerDisclaimer:
              "The content on this report is general in nature, and is provided for informational purposes only.  Boehringer Ingelheim makes no representations or warranties about the accuracy, reliability, completeness, correctness, suitability or timeliness of the content. Copyright; 2025 Boehringer Ingelheim Pharmaceuticals, Inc. All rights reserved. PC-US-143647.",
            fontHeadName: "Helvetica",
            fontTextName: "Helvetica",
          }),
          getters: {},
          actions: {
            addNewPage(e, t) {
              t || e.addPage(),
                e.setFillColor(8, 49, 42),
                e.rect(0, 0, 11, 0.3, "F"),
                e.setTextColor(255, 255, 255),
                e.setFontSize(10).setFont(this.fontHeadName, "normal"),
                e.text("CARDIO-RENAL-METABOLIC", 9, 0.2),
                e.setTextColor(0, 0, 0),
                e.setFontSize(20).setFont(this.fontHeadName, "normal"),
                e.text("The Cardio-Renal-Metabolic Map", this.xStart, 0.7),
                e
                  .setFontSize(this.footerFont)
                  .setFont(this.fontHeadName, "normal"),
                e.text(this.footerDisclaimer, this.xStart, 8, {
                  maxWidth: this.textWidth,
                });
            },
            printMapFilters(e, t) {
              const a = O();
              let o = t + this.yStart;
              e.setFontSize(this.headerFont),
                e.text("Filters and Options", this.xStart, o),
                e.setFontSize(this.paragraphFont);
              const i = [
                  `Index Condition: ${a.liveCondition}`,
                  `Comorbidity 1: ${
                    "" != a.liveComorb1 ? a.liveComorb1 : "N/A"
                  }`,
                  `Comorbidity 2: ${
                    "" != a.liveComorb2 ? a.liveComorb2 : "N/A"
                  }`,
                  `Comorbidity 3: ${
                    "" != a.liveComorb3 ? a.liveComorb3 : "N/A"
                  }`,
                  `Year: ${a.liveYear}`,
                  `Demographic/Population: ${a.livePopulation}`,
                  `Insurance: ${a.liveInsurance}`,
                  `Metric: ${a.liveMetric}`,
                ],
                s = 0.2;
              (o += s),
                i.forEach((t, a) => {
                  e.text(t, this.xStart, o + a * s);
                }),
                e.text(
                  "These summary datasets were prepared using data maintained by the Centers for Medicare and Medicaid Services (CMS), as well as on a proprietary national medical claims dataset. These datasets were processed using disease and condition identification algorithms developed by Boehringer Ingelheim. These datasets contain results that include information on social vulnerability, which is quantified using the Social Vulnerability Index from the US Centers for Disease Control.",
                  this.xStart,
                  3,
                  { maxWidth: this.textWidth }
                );
            },
            printChartFilters(e, t) {
              const a = O(),
                o = P();
              let i = t + this.yStart;
              e.setFontSize(this.headerFont),
                e.text("Filters and Options", this.xStart, i),
                e.setFontSize(this.paragraphFont);
              const s = o.liveTitle,
                d = [
                  `Index Condition: ${a.liveCondition}`,
                  `Comorbidity 1: ${
                    "" != a.liveComorb1 ? a.liveComorb1 : "N/A"
                  }`,
                  `Comorbidity 2: ${
                    "" != a.liveComorb2 ? a.liveComorb2 : "N/A"
                  }`,
                  `Comorbidity 3: ${
                    "" != a.liveComorb3 ? a.liveComorb3 : "N/A"
                  }`,
                  `Year: ${a.liveYear}`,
                  `Demographic/Population: ${a.livePopulation}`,
                  `Insurance: ${a.liveInsurance}`,
                  `Selected Geography(ies): ${s}`,
                ],
                n = 0.2;
              (i += n),
                d.forEach((t, a) => {
                  e.text(t, this.xStart, i + a * n);
                }),
                e.text(
                  "These summary datasets were prepared using data maintained by the Centers for Medicare and Medicaid Services (CMS), as well as on a proprietary national medical claims dataset. These datasets were processed using disease and condition identification algorithms developed by Boehringer Ingelheim. These datasets contain results that include information on social vulnerability, which is quantified using the Social Vulnerability Index from the US Centers for Disease Control.",
                  this.xStart,
                  3.2,
                  { maxWidth: this.textWidth }
                );
            },
            async eleToCanvasUrl(e) {
              if (e) {
                const t = await ma()(e);
                return t.toDataURL("image/png");
              }
              return "null";
            },
            printTable(e, t) {
              e.autoTable({
                html: t,
                startY: 1.1,
                margin: { left: this.xStart },
                tableWidth: this.textWidth,
                styles: {
                  font: this.fontTextName,
                  fontSize: 9,
                  halign: "left",
                  overflow: "linebreak",
                },
                headStyles: { fillColor: [8, 49, 42] },
                columnStyles: {
                  0: { cellWidth: 0.2 * this.textWidth },
                  1: { cellWidth: 0.8 * this.textWidth },
                },
                rowPageBreak: "auto",
              });
            },
          },
        });
        var _a = (0, n.pM)({
          __name: "pdf-chart-export",
          setup(e) {
            const t = O(),
              a = ua();
            async function o() {
              const e = new ra.jsPDF({
                orientation: "landscape",
                unit: "in",
                format: [11, 8.5],
                compress: !0,
              });
              async function o(t) {
                for (const o of t) {
                  const t = document.getElementById(o),
                    i = t?.clientHeight,
                    s = t?.clientWidth;
                  if (i && s) {
                    const o = s / i;
                    a.addNewPage(e, !1);
                    const d = await a.eleToCanvasUrl(t);
                    e.addImage(d, "PNG", 1, 1, 8, 8 / o);
                  }
                }
              }
              if (
                (a.addNewPage(e, !0),
                a.printChartFilters(e, 0),
                "comp" != t.selectMode)
              ) {
                a.addNewPage(e, !1);
                const t = await a.eleToCanvasUrl(
                  document.getElementById("svi-row")
                );
                e.addImage(t, "PNG", 0.2, 1.5, 10.9, 2);
              }
              await o([
                "prev-row",
                "cost-row",
                "cost-per-row",
                "mort-row",
                "hosp-row",
              ]),
                a.addNewPage(e, !1),
                a.printTable(e, "#def-table"),
                a.addNewPage(e, !1),
                a.printTable(e, "#outcome-table");
              const i = new Date().toISOString().split("T")[0];
              e.save(`BI CRM Data ${i}.pdf`);
            }
            return (e, t) => (
              (0, n.uX)(),
              (0, n.CE)(
                "button",
                {
                  onClick: t[0] || (t[0] = (e) => o()),
                  type: "button",
                  class: "print-button",
                  "aria-label": "Close",
                },
                "Print Charts "
              )
            );
          },
        });
        const ba = (0, u.A)(_a, [["__scopeId", "data-v-065f9db3"]]);
        var va = ba;
        const ha = { class: "dropdowns d-flex justify-content-evenly py-2" };
        var ya = (0, n.pM)({
          __name: "healthcare-costs-per",
          setup(e) {
            ot.t1.register(ot.PP, ot.kc, ot.E8, ot.hE, ot.m_, ot.s$);
            const t = P(),
              a = O(),
              o = (0, n.EW)(() => {
                try {
                  const e = t.liveModalData.data.filter(
                      (e) => e.YEAR == t.liveCostYear
                    ),
                    a = e.map((e) => parseFloat(e.TOTAL_ALLOW_PMPY)),
                    o = e.map((e) => parseFloat(e.IP_ALLOW_PMPY)),
                    i = e.map((e) => parseFloat(e.PAC_ALLOW_PMPY));
                  return [a, o, i];
                } catch (e) {
                  return [0];
                }
              }),
              i = (0, n.EW)(() => {
                try {
                  const e = t.liveModalNation.data.filter(
                      (e) => e.YEAR == t.liveCostYear
                    ),
                    a = e.map((e) => parseFloat(e.TOTAL_ALLOW_PMPY)),
                    o = e.map((e) => parseFloat(e.IP_ALLOW_PMPY)),
                    i = e.map((e) => parseFloat(e.PAC_ALLOW_PMPY));
                  return [a, o, i];
                } catch (e) {
                  return [0];
                }
              }),
              s = (0, n.EW)(() => ({
                labels: [
                  "All-Cause Cost",
                  "Inpatient Cost",
                  "Post-Acute Care Cost",
                ],
                datasets: [
                  {
                    label: t.legendItems1,
                    backgroundColor: "#08312A",
                    data: o.value,
                    barPercentage: 0.6,
                  },
                  ...("comp" == a.selectMode
                    ? [
                        {
                          label: t.legendItems2,
                          backgroundColor: "#00E47C",
                          data: i.value,
                          barPercentage: 0.6,
                        },
                      ]
                    : []),
                ],
              })),
              d = {
                responsive: !0,
                maintainAspectRatio: !0,
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: function (e) {
                        return e.parsed.y.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        });
                      },
                    },
                  },
                },
                scales: {
                  x: { grid: { display: !1 }, title: { display: !1 } },
                  y: {
                    min: 0,
                    grid: { display: !1 },
                    ticks: {
                      callback: function (e) {
                        return e.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        });
                      },
                    },
                    title: { display: !0, text: "Cost (USD)", color: "black" },
                  },
                },
              };
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  (0, n.Lk)("div", ha, [
                    (0, n.bF)(
                      Z,
                      {
                        idStr: "costYear-dd-2",
                        storeName: "modal",
                        vModelVar: "liveCostYear",
                        optionList: (0, c.R1)(t).yearOptions,
                      },
                      null,
                      8,
                      ["optionList"]
                    ),
                  ]),
                  (0, n.bF)(
                    (0, c.R1)(it.yP),
                    { data: s.value, options: d },
                    null,
                    8,
                    ["data"]
                  ),
                ],
                64
              )
            );
          },
        });
        const ka = ya;
        var fa = ka;
        const ga = (e) => (
            (0, n.Qi)("data-v-71b662a2"), (e = e()), (0, n.jt)(), e
          ),
          Ca = { class: "modal", id: "select-modal" },
          La = {
            class:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-wide",
          },
          Da = { class: "modal-content" },
          wa = {
            class:
              "modal-header bg-primary text-light flex-column align-items-start",
          },
          Ta = {
            class: "d-flex justify-content-between w-100 align-items-center",
          },
          Na = { class: "modal-title fs-3" },
          Ma = { key: 0 },
          Aa = { class: "w-100" },
          Sa = { class: "subtitle-font" },
          Ea = { class: "modal-body" },
          Ia = {
            key: 0,
            id: "svi-row",
            class: "row px-3 justify-content-center",
          },
          xa = { class: "col-10 py-3" },
          Ra = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Social Vulnerability Index Percentile",
              -1
            )
          ),
          Pa = { class: "fs-6 text-center" },
          Oa = ga(() => (0, n.Lk)("hr", null, null, -1)),
          Fa = { class: "row px-3 justify-content-center" },
          Ha = { id: "prev-row", class: "col-8" },
          Ya = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Disease Prevalence",
              -1
            )
          ),
          Wa = ga(() => (0, n.Lk)("hr", { class: "py-1" }, null, -1)),
          Va = { class: "row px-3 justify-content-center" },
          ja = { id: "cost-row", class: "col-8" },
          Ba = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Healthcare Costs",
              -1
            )
          ),
          $a = ga(() => (0, n.Lk)("hr", { class: "py-1" }, null, -1)),
          Xa = { class: "row px-3 justify-content-center" },
          Ua = { id: "cost-per-row", class: "col-8" },
          Ga = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Healthcare Costs Per Person",
              -1
            )
          ),
          za = ga(() => (0, n.Lk)("hr", { class: "py-1" }, null, -1)),
          Ka = { key: 1, class: "row px-3 justify-content-center" },
          Qa = { id: "mort-row", class: "col-8" },
          qa = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Mortality Rate",
              -1
            )
          ),
          Za = ga(() => (0, n.Lk)("hr", { class: "py-1" }, null, -1)),
          Ja = { class: "row px-3 justify-content-center" },
          eo = { id: "hosp-row", class: "col-8" },
          to = ga(() =>
            (0, n.Lk)(
              "div",
              { class: "fs-1 text-center" },
              "Hospitalization",
              -1
            )
          );
        var ao = (0, n.pM)({
          __name: "select-modal",
          setup(e) {
            const t = P(),
              a = O(),
              o = (0, n.EW)(() => {
                try {
                  const e =
                      "" == a.liveComorb1 ? "" : ` with ${w(a.liveComorb1)}`,
                    t = "" == a.liveComorb2 ? "" : ` and ${w(a.liveComorb2)}`,
                    o = "" == a.liveComorb3 ? "" : ` and ${w(a.liveComorb3)}`;
                  return `${w(a.liveCondition)}${e}${t}${o} in the ${
                    a.livePopulation
                  } American Population, with ${a.liveInsurance} Insurance`;
                } catch (e) {
                  return "";
                }
              }),
              i = (0, n.EW)(() =>
                "State" == a.liveSpatialStr
                  ? "National Percentiles"
                  : "In-State Percentiles"
              );
            return (e, s) => (
              (0, n.uX)(),
              (0, n.CE)("div", Ca, [
                (0, n.Lk)("div", La, [
                  (0, n.Lk)("div", Da, [
                    (0, n.Lk)("div", wa, [
                      (0, n.Lk)("div", Ta, [
                        (0, n.Lk)("h5", Na, [
                          (0, n.eW)(
                            (0, h.v_)((0, c.R1)(t).modalTitle) + " ",
                            1
                          ),
                          "County" === (0, c.R1)(a).liveSpatialStr
                            ? ((0, n.uX)(),
                              (0, n.CE)(
                                "span",
                                Ma,
                                (0, h.v_)((0, c.R1)(a).liveSpatialStr),
                                1
                              ))
                            : (0, n.Q3)("", !0),
                        ]),
                        (0, n.Lk)("div", null, [
                          (0, n.bF)(va),
                          (0, n.eW)("   "),
                          (0, n.Lk)(
                            "button",
                            {
                              onClick:
                                s[0] ||
                                (s[0] = (e) =>
                                  (0, c.R1)(t).resetModalSettings()),
                              type: "button",
                              class: "back-button",
                              "data-bs-dismiss": "modal",
                              "aria-label": "Close",
                            },
                            " Back to Map  "
                          ),
                        ]),
                      ]),
                      (0, n.Lk)("div", Aa, [
                        (0, n.Lk)("small", Sa, (0, h.v_)(o.value), 1),
                      ]),
                    ]),
                    (0, n.Lk)("div", Ea, [
                      "comp" !== (0, c.R1)(a).selectMode
                        ? ((0, n.uX)(),
                          (0, n.CE)("div", Ia, [
                            (0, n.Lk)("div", xa, [
                              Ra,
                              (0, n.Lk)("div", Pa, (0, h.v_)(i.value), 1),
                              (0, n.bF)(ca),
                            ]),
                            Oa,
                          ]))
                        : (0, n.Q3)("", !0),
                      (0, n.Lk)("div", Fa, [
                        (0, n.Lk)("div", Ha, [Ya, (0, n.bF)(bt)]),
                      ]),
                      Wa,
                      (0, n.Lk)("div", Va, [
                        (0, n.Lk)("div", ja, [Ba, (0, n.bF)(pt)]),
                      ]),
                      $a,
                      (0, n.Lk)("div", Xa, [
                        (0, n.Lk)("div", Ua, [Ga, (0, n.bF)(fa)]),
                      ]),
                      za,
                      "Commercial" != (0, c.R1)(a).liveInsurance
                        ? ((0, n.uX)(),
                          (0, n.CE)("div", Ka, [
                            (0, n.Lk)("div", Qa, [qa, (0, n.bF)(Et)]),
                          ]))
                        : (0, n.Q3)("", !0),
                      Za,
                      (0, n.Lk)("div", Ja, [
                        (0, n.Lk)("div", eo, [to, (0, n.bF)(ct)]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            );
          },
        });
        const oo = (0, u.A)(ao, [["__scopeId", "data-v-71b662a2"]]);
        var io = oo;
        const so = (e) => (
            (0, n.Qi)("data-v-e5b56dac"), (e = e()), (0, n.jt)(), e
          ),
          no = { id: "def-table", class: "table-primary text-white pt-3" },
          co = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", { class: "text-center py-2", colspan: "2" }, [
                  (0, n.Lk)("span", { class: "fw-bold py-3 pt-5 text-center" }, "Disease Definitions"),
                ]),
              ],
              -1
            )
          ),
          ro = so(() =>
            (0, n.Lk)(
              "tr",
              { class: "fw-bold" },
              [
                (0, n.Lk)("td", null, "Chronic Condition"),
                (0, n.Lk)("td", null, "Description"),
              ],
              -1
            )
          ),
          lo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Type 2 Diabetes"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for Type 2 diabetes indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          mo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Any Chronic Kidney Disease"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for any type or stage of chronic kidney disease indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          po = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "CKD 1 or 2"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for Stage 1 or Stage 2 chronic kidney disease indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          uo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "CKD 3 or 4 or 5 (ERSD)"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for Stage 3 or higher (including ESRD status) chronic kidney disease indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          _o = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "At Risk for Chronic Kidney Disease"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient without diagnosis codes for any stage of chronic kidney disease indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          bo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Heart Failure"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for any type of heart failure indicated on at least one inpatient or outpatient claim in the past two years."
                ),
              ],
              -1
            )
          ),
          vo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Systolic Heart Failure (HFrEF)"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for systolic heart failure indicated on at least one inpatient or outpatient claim in the past two years."
                ),
              ],
              -1
            )
          ),
          ho = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Diastolic Heart Failure (HFpEF)"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for diastolic heart failure indicated on at least one inpatient or outpatient claim in the past two years."
                ),
              ],
              -1
            )
          ),
          yo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Atrial Fibrillation"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for atrial fibrillation indicated on at least one inpatient or two outpatient claims in the past year."
                ),
              ],
              -1
            )
          ),
          ko = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Ischemic Heart Disease"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for ischemic heart disease indicated on at least one inpatient or outpatient claim in the past two years."
                ),
              ],
              -1
            )
          ),
          fo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Cardiac Dysrhythmia"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for cardiac dysrhythmia indicated on at least one inpatient or outpatient claim in the past two years."
                ),
              ],
              -1
            )
          ),
          go = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Cardiovascular Disease"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with any of the following conditions, as identified with that condition's specific requirements: heart failure, HFrEF, HFpEF, stroke, atrial fibrillation, ischemic heart disease, cardiac dysrhythmia."
                ),
              ],
              -1
            )
          ),
          Co = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Stroke"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for stroke indicated on at least one inpatient or two outpatient claims in the past year."
                ),
              ],
              -1
            )
          ),
          Lo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Hypertension"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for hypertension indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          Do = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Obesity"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Any patient with diagnosis codes for obesity indicated on at least one inpatient or two outpatient claims in the past two years."
                ),
              ],
              -1
            )
          ),
          wo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", { class: "text-center py-2", colspan: "2" }, [
                  (0, n.Lk)("span", { class: "fw-bold py-3 pt-5 text-center" }, "Social Vulnerability Index"),
                ]),
              ],
              -1
            )
          ),
          To = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Social Vulnerability Index (SVI)"),
                (0, n.Lk)(
                  "td",
                  null,
                  "A composite metric developed by the CDC to assess the relative vulnerability of communities based on social determinants that influence their ability to prepare for, respond to, and recover from hazardous events."
                ),
              ],
              -1
            )
          ),
          No = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Socioeconomic Status"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Encompasses indicators such as income level, poverty rate, unemployment rate, and educational attainment, reflecting economic stability and access to resources."
                ),
              ],
              -1
            )
          ),
          Mo = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Household Characteristics"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Includes demographic factors such as age distribution (e.g., elderly, children), prevalence of disabilities, and presence of single-parent households, which may affect a population's resilience and access to assistance."
                ),
              ],
              -1
            )
          ),
          Ao = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Racial and Ethnic Minority Status"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Captures racial and ethnic minority status and limited English proficiency, which can influence access to information, healthcare, and emergency services."
                ),
              ],
              -1
            )
          ),
          So = so(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Housing Type and Transportation"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Reflects housing characteristics (e.g., multi-unit structures, mobile homes, overcrowding) and access to transportation, which affect mobility and sheltering options during emergencies."
                ),
              ],
              -1
            )
          ),
          Eo = [
            co,
            ro,
            lo,
            mo,
            po,
            uo,
            _o,
            bo,
            vo,
            ho,
            yo,
            ko,
            fo,
            go,
            Co,
            Lo,
            Do,
            wo,
            To,
            No,
            Mo,
            Ao,
            So,
          ];
        function Io(e, t) {
          return (0, n.uX)(), (0, n.CE)("table", no, Eo);
        }
        const xo = {},
          Ro = (0, u.A)(xo, [
            ["render", Io],
            ["__scopeId", "data-v-e5b56dac"],
          ]);
        var Po = Ro;
        const Oo = (e) => (
            (0, n.Qi)("data-v-7c6c20d6"), (e = e()), (0, n.jt)(), e
          ),
          Fo = { id: "outcome-table", class: "table-primary text-white pt-3" },
          Ho = Oo(() =>
            (0, n.Lk)(
              "tr",
              { class: "fw-bold" },
              [
                (0, n.Lk)("td", null, "Metric"),
                (0, n.Lk)("td", null, "Description"),
              ],
              -1
            )
          ),
          Yo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Prevalence"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Count of individuals with the condition as a proportion of the total population."
                ),
              ],
              -1
            )
          ),
          Wo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "All-cause cost"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Allowed amount per member per year for all services, across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          Vo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Inpatient cost"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Allowed amount per member per year for inpatient services, across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          jo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Post-Acute Care Cost"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Allowed amount per member per year for post-acute care services (SNF and Home Health), across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          Bo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Hospital days"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Inpatient days per member per year, across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          $o = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Hospital episodes"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Percentage of individuals with at least one inpatient stay during the year, across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          Xo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Hospital rate"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Average annual inpatient admissions per 1,000 individuals across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          Uo = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Mortality rate"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Percentage of individuals with a non-null death date in the enrollment record, across all individuals in the breakout."
                ),
              ],
              -1
            )
          ),
          Go = Oo(() =>
            (0, n.Lk)(
              "tr",
              null,
              [
                (0, n.Lk)("td", null, "Readmission rate"),
                (0, n.Lk)(
                  "td",
                  null,
                  "Percentage of qualifying inpatient stays that led to a readmission within 30 days, following the CMS 30-Day All-Cause Readmission methodology."
                ),
              ],
              -1
            )
          ),
          zo = [Ho, Yo, Wo, Vo, jo, Bo, $o, Xo, Uo, Go];
        function Ko(e, t) {
          return (0, n.uX)(), (0, n.CE)("table", Fo, zo);
        }
        const Qo = {},
          qo = (0, u.A)(Qo, [
            ["render", Ko],
            ["__scopeId", "data-v-7c6c20d6"],
          ]);
        var Zo = qo;
        const Jo = (e) => (
            (0, n.Qi)("data-v-da3a41ee"), (e = e()), (0, n.jt)(), e
          ),
          ei = Jo(() =>
            (0, n.Lk)(
              "div",
              { class: "py-3 px-5" },
              " Certain regions have an insufficient population sample size to determine values with any level of confidence. Index and comorbid disease do not represent all possible combinations of patient experience. They are selected by Boehringer Ingelheim to highlight specific examples of disease interactions. ",
              -1
            )
          ),
          ti = { class: "row justify-content-center mont-font" },
          ai = { class: "col-11" },
          oi = { class: "accordion shadow", id: "notesAccordian" },
          ii = { class: "accordion-item" },
          si = Jo(() =>
            (0, n.Lk)(
              "div",
              { class: "accordion-header" },
              [
                (0, n.Lk)(
                  "button",
                  {
                    class: "accordion-button p-3 fs-5 bg-primary",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#collapseNotesSection",
                  },
                  [
                    (0, n.Lk)(
                      "div",
                      { class: "btn-text" },
                      " References and Methodology "
                    ),
                  ]
                ),
              ],
              -1
            )
          ),
          di = {
            id: "collapseNotesSection",
            class: "accordion-collapse collapse bg-primary show",
            "data-bs-parent": "#notesAccordian",
          },
          ni = { class: "accordion-body text-white" },
          ci = Jo(() =>
            (0, n.Lk)(
              "div",
              { class: "fw-bold" },
              " Cardio-Renal-Metabolic Map Reference ",
              -1
            )
          ),
          ri = Jo(() =>
            (0, n.Lk)(
              "a",
              {
                target: "_blank",
                href:
                  "https://www.atsdr.cdc.gov/place-health/php/svi/index.html",
              },
              "US Centers for Disease Control",
              -1
            )
          ),
          li = { class: "def-table" },
          mi = Jo(() =>
            (0, n.Lk)(
              "div",
              { class: "fw-bold py-3 pt-5 text-center" },
              " Metric Defintions ",
              -1
            )
          ),
          pi = { class: "outcome-table" };
        var ui = (0, n.pM)({
          __name: "notes-container",
          setup(e) {
            const t = O(),
              a = (0, n.EW)(() => {
                const e = t.yearsList.slice(-5),
                  a = `${e[0]}-${e[e.length - 1]}`;
                return a;
              });
            return (e, t) => (
              (0, n.uX)(),
              (0, n.CE)(
                n.FK,
                null,
                [
                  ei,
                  (0, n.Lk)("div", ti, [
                    (0, n.Lk)("div", ai, [
                      (0, n.Lk)("div", oi, [
                        (0, n.Lk)("div", ii, [
                          si,
                          (0, n.Lk)("div", di, [
                            (0, n.Lk)("div", ni, [
                              ci,
                              (0, n.Lk)("div", null, [
                                (0, n.eW)(
                                  " These summary datasets were prepared using data maintained by the Centers for Medicare and Medicaid Services (CMS), as well as on a proprietary national medical claims dataset, for years " +
                                    (0, h.v_)(a.value) +
                                    ". These datasets were processed using disease and condition identification algorithms developed by Boehringer Ingelheim. These datasets contain results that include information on social vulnerability, which is quantified using the Social Vulnerability Index from the ",
                                  1
                                ),
                                ri,
                                (0, n.eW)(". "),
                              ]),
                              (0, n.Lk)("div", li, [(0, n.bF)(Po)]),
                              mi,
                              (0, n.Lk)("div", pi, [(0, n.bF)(Zo)]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                64
              )
            );
          },
        });
        const _i = (0, u.A)(ui, [["__scopeId", "data-v-da3a41ee"]]);
        var bi = _i,
          vi = a(1304),
          hi = a(4026);
        const yi = ["id"],
          ki = ["value"],
          fi = ["value"],
          gi = ["value"];
        var Ci = (0, n.pM)({
          __name: "radio-brand",
          props: {
            idStr: { default: "Placeholder ID" },
            vModelVar: { default: "Empty" },
            storeName: { default: "options" },
            selectArr: { default: () => ["Option 1", "Option 2", "Option 3"] },
            valueArr: { default: () => ["One", "Two", "Three"] },
          },
          setup(e) {
            const t = e;
            let a;
            "spatial" == t.storeName
              ? (a = R())
              : "modal" == t.storeName
              ? (a = P())
              : "options" == t.storeName && (a = O());
            const i = (0, n.EW)({
              get() {
                return a[t.vModelVar];
              },
              set(e) {
                a[t.vModelVar] = e;
              },
            });
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)(
                "div",
                { class: "three-toggle", id: t.idStr },
                [
                  (0, n.Lk)("div", null, [
                    (0, n.Lk)("label", null, [
                      (0, n.bo)(
                        (0, n.Lk)(
                          "input",
                          {
                            type: "radio",
                            name: "radio",
                            "onUpdate:modelValue":
                              a[0] || (a[0] = (e) => (i.value = e)),
                            value: t.valueArr[0],
                          },
                          null,
                          8,
                          ki
                        ),
                        [[o.XL, i.value]]
                      ),
                      (0, n.Lk)("span", null, (0, h.v_)(t.selectArr[0]), 1),
                    ]),
                    (0, n.Lk)("label", null, [
                      (0, n.bo)(
                        (0, n.Lk)(
                          "input",
                          {
                            type: "radio",
                            name: "radio",
                            "onUpdate:modelValue":
                              a[1] || (a[1] = (e) => (i.value = e)),
                            value: t.valueArr[1],
                          },
                          null,
                          8,
                          fi
                        ),
                        [[o.XL, i.value]]
                      ),
                      (0, n.Lk)("span", null, (0, h.v_)(t.selectArr[1]), 1),
                    ]),
                    (0, n.Lk)("label", null, [
                      (0, n.bo)(
                        (0, n.Lk)(
                          "input",
                          {
                            type: "radio",
                            name: "radio",
                            "onUpdate:modelValue":
                              a[2] || (a[2] = (e) => (i.value = e)),
                            value: t.valueArr[2],
                          },
                          null,
                          8,
                          gi
                        ),
                        [[o.XL, i.value]]
                      ),
                      (0, n.Lk)("span", null, (0, h.v_)(t.selectArr[2]), 1),
                    ]),
                  ]),
                ],
                8,
                yi
              )
            );
          },
        });
        const Li = (0, u.A)(Ci, [["__scopeId", "data-v-76f03d5b"]]);
        var Di = Li;
        const wi = (e) => (
            (0, n.Qi)("data-v-17949f36"), (e = e()), (0, n.jt)(), e
          ),
          Ti = { class: "legend-wrapper" },
          Ni = { class: "legend-text text-center" },
          Mi = wi(() => (0, n.Lk)("div", { id: "legend-gradient" }, null, -1)),
          Ai = { class: "legend-text text-center" };
        var Si = (0, n.pM)({
          __name: "legend",
          setup(e) {
            const t = O();
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)("div", Ti, [
                (0, n.Lk)(
                  "div",
                  Ni,
                  (0, h.v_)(
                    (0, c.R1)(N)(
                      (0, c.R1)(t).getDataBounds.max,
                      (0, c.R1)(t).currentFormat
                    )
                  ),
                  1
                ),
                Mi,
                (0, n.Lk)(
                  "div",
                  Ai,
                  (0, h.v_)(
                    (0, c.R1)(N)(
                      (0, c.R1)(t).getDataBounds.min,
                      (0, c.R1)(t).currentFormat
                    )
                  ),
                  1
                ),
              ])
            );
          },
        });
        const Ei = (0, u.A)(Si, [["__scopeId", "data-v-17949f36"]]);
        var Ii = Ei;
        const xi = (e) => (
            (0, n.Qi)("data-v-c67cbeae"), (e = e()), (0, n.jt)(), e
          ),
          Ri = xi(() =>
            (0, n.Lk)(
              "path",
              {
                d:
                  "M5,21V3H14.2070999l4.7929001,4.7928901v13.2071099H5Zm1-1h12V9h-4v-1h3.7929001l-3.7929001-3.7928901v3.7928901h-1V4H6V20Zm2-6h5v-1h-5v1Zm8,3H8v-1h8v1Z",
                style: { "fill-rule": "evenodd", stroke: "white" },
              },
              null,
              -1
            )
          ),
          Pi = [Ri];
        var Oi = (0, n.pM)({
          __name: "pdf-map-export",
          setup(e) {
            const t = ua();
            async function a() {
              const e = new ra.jsPDF({
                orientation: "landscape",
                unit: "in",
                format: [11, 8.5],
                compress: !0,
              });
              t.addNewPage(e, !0), t.printMapFilters(e, 0), t.addNewPage(e, !1);
              const a = await t.eleToCanvasUrl(
                document.getElementById("map-container")
              );
              e.addImage(a, "PNG", 1, 1, 8.46, 6),
                e.text(
                  "Certain regions have an insufficient population sample size to determine values with any level of confidence. Index and comorbid disease do not represent all possible combinations of patient experience. They are selected by Boehringer Ingelheim to highlight specific examples of disease interactions.",
                  0.25,
                  7.2,
                  { maxWidth: 10.25 }
                ),
                t.addNewPage(e, !1),
                t.printTable(e, "#def-table"),
                t.addNewPage(e, !1),
                t.printTable(e, "#outcome-table");
              const o = new Date().toISOString().split("T")[0];
              e.save(`BI CRM Map Data ${o}.pdf`);
            }
            return (e, t) => (
              (0, n.uX)(),
              (0, n.CE)(
                "svg",
                {
                  onClick: t[0] || (t[0] = (e) => a()),
                  id: "print-map",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
                Pi
              )
            );
          },
        });
        const Fi = (0, u.A)(Oi, [["__scopeId", "data-v-c67cbeae"]]);
        var Hi = Fi;
        const Yi = { class: "text-center" },
          Wi = { class: "row justify-content-center pt-3" },
          Vi = { class: "col-11" },
          ji = { class: "mapper shadow rounded", id: "map-container" },
          Bi = {
            class:
              "p-2 bg-primary rounded-top text-white d-flex justify-content-between",
          },
          $i = { id: "placeholder-map" },
          Xi = 600,
          Ui = 400;
        var Gi = (0, n.pM)({
          __name: "map-wrapper",
          setup(e) {
            const t = R(),
              a = O(),
              i = P(),
              s = [
                "#f5ccb8",
                "#e8b7a1",
                "#daa38b",
                "#cd8e76",
                "#bf7a62",
                "#b2664f",
                "#a4523d",
                "#953d2c",
                "#87271c",
              ];
            let r = (0, c.KR)("");
            function l() {
              const e = "" == a.liveComorb1 ? "" : ` with ${w(a.liveComorb1)}`,
                t = "" == a.liveComorb2 ? "" : ` and ${w(a.liveComorb2)}`,
                o = "" == a.liveComorb3 ? "" : ` and ${w(a.liveComorb3)}`;
              r.value = `${a.liveMetric} of ${w(
                a.liveCondition
              )}${e}${t}${o} in ${a.liveYear} of the ${
                a.livePopulation
              } American Population, with ${a.liveInsurance} Insurance`;
            }
            async function m(e) {
              const t = document.getElementById("select-modal");
              if (t) {
                const a = new d.aF(t);
                (i.currentGeo = { id: e.id, name: e.properties.name }),
                  await i.fetchChartData(!1),
                  await i.fetchChartData(!0),
                  a.show();
              }
            }
            async function p() {
              const e = t.spatialBase;
              if (!e) return;
              const o = a.liveData,
                i = new Map(o.map((e) => [String(e.id), e.metric])),
                d = vi.WT_([a.getDataBounds.min, a.getDataBounds.max], s),
                n = vi.zFW(),
                c = vi
                  .vtF("svg")
                  .attr("viewBox", [0, 0, Xi, Ui])
                  .attr("id", "map-svg"),
                r = "State" === a.liveSpatialStr ? "states" : "counties";
              vi.Ltv("#map-container").select(".tooltip-map").remove();
              const l = vi
                  .Ltv("#map-container")
                  .append("div")
                  .classed("tooltip-map", !0)
                  .style("opacity", 0)
                  .style("z-index", 10),
                p = function (e, t) {
                  l.style("opacity", 1).style("z-index", 100);
                },
                u = function (e) {
                  l.html(D(e.properties.name, r, i.get(e.id), a.currentFormat))
                    .style("top", vi.f0J.y - 140 + "px")
                    .style("left", vi.f0J.x + "px");
                },
                _ = function (e, t) {
                  l.style("opacity", 0), l.style("z-index", -1);
                },
                b = c.append("g");
              if (
                (b
                  .selectAll("path")
                  .data(hi.N4(e, e.objects[r]).features)
                  .join("path")
                  .classed("geo-path", !0)
                  .attr("fill", function (e) {
                    return i.get(e.id) ? d(i.get(e.id)) : "#b8b8b8";
                  })
                  .attr("d", n)
                  .attr("id", (e) => e.id)
                  .attr("stroke", "white")
                  .attr("stroke-width", 0.5)
                  .on("click", function (e) {
                    if ("single" != a.selectMode) {
                      const a = vi.Ltv(this),
                        o = t.liveNames.find((t) => t.id == e.id),
                        i = { id: e.id, name: o?.name };
                      a.classed("selected")
                        ? t.removeGeoItemFromLive(i)
                        : t.addCurrentToLive(i);
                    } else m(e);
                  })
                  .on("mouseover", p)
                  .on("mousemove", u)
                  .on("mouseleave", _),
                "State" === a.liveSpatialStr)
              ) {
                const a = new Map(
                  t.abbrvMap.map((e) => [String(e.id), e.stateAbbrv])
                );
                b.selectAll("text")
                  .data(hi.N4(e, e.objects[r]).features)
                  .join("text")
                  .attr("x", (e) => n.centroid(e)[0])
                  .attr("y", (e) => n.centroid(e)[1])
                  .attr("text-anchor", "middle")
                  .attr("dominant-baseline", "central")
                  .text((e) => {
                    const t = n.bounds(e),
                      o = t[1][0] - t[0][0],
                      i = t[1][1] - t[0][1],
                      s = 35;
                    return (o > s && i > s && a.get(e.id)) || "";
                  })
                  .attr("font-size", "12px")
                  .attr("fill", "white")
                  .classed("map-label", !0);
              }
              const v = vi
                .s_O()
                .scaleExtent([0.5, 10])
                .extent([
                  [0, 0],
                  [Xi, Ui],
                ])
                .on("zoom", () => b.attr("transform", vi.f0J.transform));
              return (
                c.call(v),
                c.call(v.transform, vi.GSI.translate(10, 20).scale(0.6)),
                c.node()
              );
            }
            async function u() {
              const e = document.querySelector(".mapper");
              if (e) {
                vi.Ltv(e).select("#map-svg").remove();
                const t = await p();
                e.appendChild(t);
                const a = (e) => e.preventDefault();
                e.addEventListener("wheel", a, { passive: !1 });
              }
            }
            return (
              (0, n.sV)(async () => {
                a.isApiIssue ||
                  (await t.fetchBaseMap(),
                  await a.fetchNationData(),
                  await a.fetchMapData(!0),
                  await u(),
                  l()),
                  (0, n.wB)(
                    () => a.liveData,
                    async () => {
                      await a.fetchNationData(), await u(), l();
                    }
                  );
              }),
              (e, t) => (
                (0, n.uX)(),
                (0, n.CE)(
                  n.FK,
                  null,
                  [
                    (0, n.Lk)("div", Yi, [
                      (0, n.bF)(Di, {
                        selectArr: [
                          "Single Select",
                          "Multi Select",
                          "Comparison",
                        ],
                        class: "multi-toggle",
                        idStr: "multiToggle",
                        storeName: "options",
                        vModelVar: "selectMode",
                        valueArr: ["single", "multi", "comp"],
                      }),
                    ]),
                    (0, n.Lk)("div", Wi, [
                      (0, n.Lk)("div", Vi, [
                        (0, n.Lk)("div", ji, [
                          (0, n.Lk)("div", Bi, [
                            (0, n.eW)((0, h.v_)((0, c.R1)(r)) + " ", 1),
                            (0, n.bF)(Hi),
                          ]),
                          (0, n.bF)(Ii),
                          (0, n.bo)((0, n.Lk)("div", $i, null, 512), [
                            [
                              o.aG,
                              (0, c.R1)(a).dataLoading &&
                                !(0, c.R1)(a).modalLoading,
                            ],
                          ]),
                        ]),
                      ]),
                    ]),
                  ],
                  64
                )
              )
            );
          },
        });
        const zi = (0, u.A)(Gi, [["__scopeId", "data-v-eaf5ab10"]]);
        var Ki = zi;
        const Qi = (e) => (
            (0, n.Qi)("data-v-04eafc7e"), (e = e()), (0, n.jt)(), e
          ),
          qi = Qi(() => (0, n.Lk)("div", { class: "overlay" }, null, -1)),
          Zi = Qi(() => (0, n.Lk)("div", { class: "spinner" }, null, -1)),
          Ji = { class: "row justify-content-center progress-wrapper mx-0" },
          es = { class: "col-4" },
          ts = { class: "progress" };
        var as = (0, n.pM)({
          __name: "data-loader",
          setup(e) {
            const t = O(),
              a = (0, c.KR)(0);
            function o(e, t) {
              const o = setInterval(() => {
                a.value + t > 98 ? clearInterval(o) : (a.value += t);
              }, e);
            }
            return (
              "State" === t.liveSpatialStr ? o(10, 2) : o(100, 1),
              (e, t) => (
                (0, n.uX)(),
                (0, n.CE)(
                  n.FK,
                  null,
                  [
                    qi,
                    Zi,
                    (0, n.Lk)("div", Ji, [
                      (0, n.Lk)("div", es, [
                        (0, n.Lk)("div", ts, [
                          (0, n.Lk)(
                            "div",
                            {
                              class:
                                "progress-bar progress-bar-striped bg-success progress-bar-animated text-dark",
                              role: "progressbar",
                              style: (0, h.Tr)({ width: a.value + "%" }),
                            },
                            (0, h.v_)(a.value) + "%",
                            5
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  64
                )
              )
            );
          },
        });
        const os = (0, u.A)(as, [["__scopeId", "data-v-04eafc7e"]]);
        var is = os,
          ss = a(7916);
        const ds = { class: "pb-2" },
          ns = ["disabled"],
          cs = { class: "py-2" },
          rs = { class: "text-danger" },
          ls = { class: "tags pb-4" },
          ms = { class: "tag" },
          ps = ["onClick"],
          us = { class: "button-wrapper" },
          _s = ["disabled"],
          bs = ["disabled"];
        var vs = (0, n.pM)({
          __name: "multi-select-input",
          setup(e) {
            const t = R(),
              a = P(),
              i = O(),
              s = (0, c.KR)(""),
              r = (0, c.KR)(),
              l = (0, c.KR)();
            function m(e) {
              l.value &&
                ((r.value = l.value.filter((t) =>
                  t.name.toLowerCase().includes(e.query.toLowerCase())
                )),
                r.value.sort((e, t) => e.name.localeCompare(t.name)));
            }
            async function p() {
              const e = document.getElementById("select-modal");
              if (e) {
                const t = new d.aF(e);
                "multi" == i.selectMode
                  ? (await a.fetchChartData(!0), await a.fetchMultiChart(!1))
                  : await a.fetchMultiChart(!0),
                  t.show();
              }
            }
            function u(e) {
              e
                ? (t.addCurrentToLive(e), (s.value = ""))
                : alert("Please select geography from the dropdown");
            }
            return (
              (0, n.sV)(() => {
                (0, n.wB)(
                  () => t.liveNames,
                  (e) => {
                    l.value = e;
                  },
                  { immediate: !0 }
                );
              }),
              (e, a) => (
                (0, n.uX)(),
                (0, n.CE)(
                  n.FK,
                  null,
                  [
                    (0, n.Lk)(
                      "div",
                      ds,
                      "Select up to " +
                        (0, h.v_)((0, c.R1)(i).selectMax) +
                        " locations",
                      1
                    ),
                    (0, n.bF)(
                      (0, c.R1)(ss.A),
                      {
                        modelValue: s.value,
                        "onUpdate:modelValue":
                          a[0] || (a[0] = (e) => (s.value = e)),
                        suggestions: r.value,
                        onComplete: m,
                        forceSelection: "",
                        dropdown: "",
                        optionLabel: "name",
                        placeholder: "Search for location",
                        id: "geoAutoComplete",
                      },
                      null,
                      8,
                      ["modelValue", "suggestions"]
                    ),
                    (0, n.Lk)(
                      "button",
                      {
                        disabled:
                          (0, c.R1)(t).liveMultiSelect.length >=
                          (0, c.R1)(i).selectMax,
                        onClick: a[1] || (a[1] = (e) => u(s.value)),
                        class: "btn btn-sm btn-primary",
                      },
                      "Add",
                      8,
                      ns
                    ),
                    (0, n.Lk)("div", cs, [
                      (0, n.eW)("Current Selections "),
                      (0, n.bo)(
                        (0, n.Lk)("span", rs, "(Max number selected)", 512),
                        [
                          [
                            o.aG,
                            (0, c.R1)(t).liveMultiSelect.length >=
                              (0, c.R1)(i).selectMax,
                          ],
                        ]
                      ),
                    ]),
                    (0, n.Lk)("div", ls, [
                      ((0, n.uX)(!0),
                      (0, n.CE)(
                        n.FK,
                        null,
                        (0, n.pI)(
                          (0, c.R1)(t).liveMultiSelect,
                          (e) => (
                            (0, n.uX)(),
                            (0, n.CE)("div", ms, [
                              (0, n.eW)((0, h.v_)(e.name) + " ", 1),
                              (0, n.Lk)(
                                "button",
                                {
                                  class: "close-btn",
                                  onClick: (a) =>
                                    (0, c.R1)(t).removeGeoItemFromLive(e),
                                },
                                "×",
                                8,
                                ps
                              ),
                            ])
                          )
                        ),
                        256
                      )),
                    ]),
                    (0, n.Lk)("div", us, [
                      (0, n.Lk)(
                        "button",
                        {
                          onClick: p,
                          disabled: (0, c.R1)(t).liveMultiSelect.length < 2,
                          class: "btn btn-sm btn-secondary",
                        },
                        "Show Geographies",
                        8,
                        _s
                      ),
                      (0, n.Lk)(
                        "button",
                        {
                          onClick:
                            a[2] ||
                            (a[2] = (...e) =>
                              (0, c.R1)(t).clearMultiSelect &&
                              (0, c.R1)(t).clearMultiSelect(...e)),
                          disabled: 0 == (0, c.R1)(t).liveMultiSelect.length,
                          class: "btn btn-sm btn-light",
                        },
                        "Clear Selections",
                        8,
                        bs
                      ),
                    ]),
                  ],
                  64
                )
              )
            );
          },
        });
        const hs = (0, u.A)(vs, [["__scopeId", "data-v-32b3d879"]]);
        var ys = hs;
        const ks = (e) => (
            (0, n.Qi)("data-v-c04b3c86"), (e = e()), (0, n.jt)(), e
          ),
          fs = {
            class: "modal",
            id: "draggable",
            "data-bs-backdrop": "static",
            "data-bs-keyboard": "false",
            tabindex: "-1",
            "aria-labelledby": "staticBackdropLabel",
            "aria-hidden": "true",
          },
          gs = { class: "modal-dialog" },
          Cs = { class: "modal-content" },
          Ls = { class: "modal-header", id: "modal-header-drag" },
          Ds = ks(() =>
            (0, n.Lk)(
              "div",
              { class: "modal-title fs-5", id: "staticBackdropLabel" },
              "Select Geographies Below ",
              -1
            )
          ),
          ws = { class: "modal-body" },
          Ts = { class: "px-2" };
        var Ns = (0, n.pM)({
          __name: "multi-select",
          setup(e) {
            const t = R(),
              a = O();
            function o(e) {
              const t = document.getElementById(e),
                a = document.getElementById("modal-header-drag");
              let o = 0,
                i = 0;
              const s = (e) => {
                  if (e.target?.closest && e.target.closest(".btn-close"))
                    return;
                const a = "touches" in e ? e.touches[0].clientX : e.clientX,
                  s = "touches" in e ? e.touches[0].clientY : e.clientY,
                  d = t.getBoundingClientRect();
                (o = a - d.left), (i = s - d.top);
                const n = (e) => {
                    const a = "touches" in e ? e.touches[0].clientX : e.clientX,
                      s = "touches" in e ? e.touches[0].clientY : e.clientY;
                    (t.style.left = a - o + "px"), (t.style.top = s - i + "px");
                  },
                  c = () => {
                    document.removeEventListener("mousemove", n),
                      document.removeEventListener("mouseup", c),
                      document.removeEventListener("touchmove", n),
                      document.removeEventListener("touchend", c);
                  };
                document.addEventListener("mousemove", n),
                  document.addEventListener("mouseup", c),
                  document.addEventListener("touchmove", n),
                  document.addEventListener("touchend", c),
                  e.preventDefault();
              };
              a.addEventListener("mousedown", s),
                a.addEventListener("touchstart", s);
            }
            function i(e) {
              const o = document.getElementById(e);
              (o.style.display = "none"),
                t.clearMultiSelect(),
                (a.selectMode = "single");
            }
            function s(e) {
              const t = document.getElementById(e);
              (t.style.top = "10%"),
                (t.style.left = "60%"),
                (t.style.display = "block");
            }
            return (
              (0, n.sV)(() => {
                o("draggable"),
                  (0, n.wB)(
                    () => a.selectMode,
                    () => {
                      "single" != a.selectMode
                        ? (t.clearMultiSelect(), s("draggable"))
                        : i("draggable");
                    }
                  );
              }),
              (e, t) => (
                (0, n.uX)(),
                (0, n.CE)("div", fs, [
                  (0, n.Lk)("div", gs, [
                    (0, n.Lk)("div", Cs, [
                      (0, n.Lk)("div", Ls, [
                        Ds,
                        (0, n.Lk)("button", {
                          type: "button",
                          class: "btn-close",
                          onClick: t[0] || (t[0] = (e) => i("draggable")),
                            onMousedown:
                              t[1] ||
                              (t[1] = (e) => {
                                e.stopPropagation();
                              }),
                            onTouchstart:
                              t[2] ||
                              (t[2] = (e) => {
                                e.stopPropagation();
                              }),
                          "aria-label": "Close",
                        }),
                      ]),
                      (0, n.Lk)("div", ws, [
                        (0, n.Lk)("div", Ts, [(0, n.bF)(ys)]),
                      ]),
                    ]),
                  ]),
                ])
              )
            );
          },
        });
        const Ms = (0, u.A)(Ns, [["__scopeId", "data-v-c04b3c86"]]);
        var As = Ms;
        const Ss = (e) => (
            (0, n.Qi)("data-v-b7c2b5a4"), (e = e()), (0, n.jt)(), e
          ),
          Es = { class: "container-fluid p-0 full-height" };
        var Os = (0, n.pM)({
          __name: "desktop-layout",
          setup(e) {
            const t = O();
            return (e, a) => (
              (0, n.uX)(),
              (0, n.CE)("div", Es, [
                (0, c.R1)(t).dataLoading
                  ? ((0, n.uX)(), (0, n.Wv)(is, { key: 0 }))
                  : (0, n.Q3)("", !0),
                (0, n.bF)(v),
                (0, n.bF)(at),
                (0, n.bF)(Ki),
                (0, n.bF)(As),
                (0, n.bF)(io),
                (0, n.bF)(bi),
              ])
            );
          },
        });
        const Fs = (0, u.A)(Os, [["__scopeId", "data-v-b7c2b5a4"]]);
        var Hs = Fs,
          Ys = (0, n.pM)({
            __name: "App",
            setup(e) {
              return (
                (0, n.KC)(async () => {
                  await O().fetchCurrentYears();
                }),
                (e, t) => ((0, n.uX)(), (0, n.Wv)(Hs))
              );
            },
          });
        const Ws = Ys;
        var Vs = Ws;
        (0, o.Ef)(Vs)
          .use((0, i.Ey)())
          .use(s.Ay)
          .mount("#app");
      },
    },
    t = {};
  function a(o) {
    var i = t[o];
    if (void 0 !== i) return i.exports;
    var s = (t[o] = { exports: {} });
    return e[o].call(s.exports, s, s.exports, a), s.exports;
  }
  (a.m = e),
    (function () {
      var e = [];
      a.O = function (t, o, i, s) {
        if (!o) {
          var d = 1 / 0;
          for (l = 0; l < e.length; l++) {
            (o = e[l][0]), (i = e[l][1]), (s = e[l][2]);
            for (var n = !0, c = 0; c < o.length; c++)
              (!1 & s || d >= s) &&
              Object.keys(a.O).every(function (e) {
                return a.O[e](o[c]);
              })
                ? o.splice(c--, 1)
                : ((n = !1), s < d && (d = s));
            if (n) {
              e.splice(l--, 1);
              var r = i();
              void 0 !== r && (t = r);
            }
          }
          return t;
        }
        s = s || 0;
        for (var l = e.length; l > 0 && e[l - 1][2] > s; l--) e[l] = e[l - 1];
        e[l] = [o, i, s];
      };
    })(),
    (function () {
      a.n = function (e) {
        var t =
          e && e.__esModule
            ? function () {
                return e["default"];
              }
            : function () {
                return e;
              };
        return a.d(t, { a: t }), t;
      };
    })(),
    (function () {
      var e,
        t = Object.getPrototypeOf
          ? function (e) {
              return Object.getPrototypeOf(e);
            }
          : function (e) {
              return e.__proto__;
            };
      a.t = function (o, i) {
        if ((1 & i && (o = this(o)), 8 & i)) return o;
        if ("object" === typeof o && o) {
          if (4 & i && o.__esModule) return o;
          if (16 & i && "function" === typeof o.then) return o;
        }
        var s = Object.create(null);
        a.r(s);
        var d = {};
        e = e || [null, t({}), t([]), t(t)];
        for (
          var n = 2 & i && o;
          "object" == typeof n && !~e.indexOf(n);
          n = t(n)
        )
          Object.getOwnPropertyNames(n).forEach(function (e) {
            d[e] = function () {
              return o[e];
            };
          });
        return (
          (d["default"] = function () {
            return o;
          }),
          a.d(s, d),
          s
        );
      };
    })(),
    (function () {
      a.d = function (e, t) {
        for (var o in t)
          a.o(t, o) &&
            !a.o(e, o) &&
            Object.defineProperty(e, o, { enumerable: !0, get: t[o] });
      };
    })(),
    (function () {
      (a.f = {}),
        (a.e = function (e) {
          return Promise.all(
            Object.keys(a.f).reduce(function (t, o) {
              return a.f[o](e, t), t;
            }, [])
          );
        });
    })(),
    (function () {
      a.u = function (e) {
        return (
          "js/" + e + "." + { 179: "1e5b2912", 234: "268a4e4c" }[e] + ".js"
        );
      };
    })(),
    (function () {
      a.miniCssF = function (e) {};
    })(),
    (function () {
      a.g = (function () {
        if ("object" === typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e) {
          if ("object" === typeof window) return window;
        }
      })();
    })(),
    (function () {
      a.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      };
    })(),
    (function () {
      var e = {},
        t = "bi_240054-crm-heatmap:";
      a.l = function (o, i, s, d) {
        if (e[o]) e[o].push(i);
        else {
          var n, c;
          if (void 0 !== s)
            for (
              var r = document.getElementsByTagName("script"), l = 0;
              l < r.length;
              l++
            ) {
              var m = r[l];
              if (
                m.getAttribute("src") == o ||
                m.getAttribute("data-webpack") == t + s
              ) {
                n = m;
                break;
              }
            }
          n ||
            ((c = !0),
            (n = document.createElement("script")),
            (n.charset = "utf-8"),
            (n.timeout = 120),
            a.nc && n.setAttribute("nonce", a.nc),
            n.setAttribute("data-webpack", t + s),
            (n.src = o)),
            (e[o] = [i]);
          var p = function (t, a) {
              (n.onerror = n.onload = null), clearTimeout(u);
              var i = e[o];
              if (
                (delete e[o],
                n.parentNode && n.parentNode.removeChild(n),
                i &&
                  i.forEach(function (e) {
                    return e(a);
                  }),
                t)
              )
                return t(a);
            },
            u = setTimeout(
              p.bind(null, void 0, { type: "timeout", target: n }),
              12e4
            );
          (n.onerror = p.bind(null, n.onerror)),
            (n.onload = p.bind(null, n.onload)),
            c && document.head.appendChild(n);
        }
      };
    })(),
    (function () {
      a.r = function (e) {
        "undefined" !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      };
    })(),
    (function () {
      a.p = "/";
    })(),
    (function () {
      var e = { 524: 0 };
      (a.f.j = function (t, o) {
        var i = a.o(e, t) ? e[t] : void 0;
        if (0 !== i)
          if (i) o.push(i[2]);
          else {
            var s = new Promise(function (a, o) {
              i = e[t] = [a, o];
            });
            o.push((i[2] = s));
            var d = a.p + a.u(t),
              n = new Error(),
              c = function (o) {
                if (a.o(e, t) && ((i = e[t]), 0 !== i && (e[t] = void 0), i)) {
                  var s = o && ("load" === o.type ? "missing" : o.type),
                    d = o && o.target && o.target.src;
                  (n.message =
                    "Loading chunk " + t + " failed.\n(" + s + ": " + d + ")"),
                    (n.name = "ChunkLoadError"),
                    (n.type = s),
                    (n.request = d),
                    i[1](n);
                }
              };
            a.l(d, c, "chunk-" + t, t);
          }
      }),
        (a.O.j = function (t) {
          return 0 === e[t];
        });
      var t = function (t, o) {
          var i,
            s,
            d = o[0],
            n = o[1],
            c = o[2],
            r = 0;
          if (
            d.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (i in n) a.o(n, i) && (a.m[i] = n[i]);
            if (c) var l = c(a);
          }
          for (t && t(o); r < d.length; r++)
            (s = d[r]), a.o(e, s) && e[s] && e[s][0](), (e[s] = 0);
          return a.O(l);
        },
        o = (self["webpackChunkbi_240054_crm_heatmap"] =
          self["webpackChunkbi_240054_crm_heatmap"] || []);
      o.forEach(t.bind(null, 0)), (o.push = t.bind(null, o.push.bind(o)));
    })();
  var o = a.O(void 0, [504], function () {
    return a(4215);
  });
  o = a.O(o);
})();
